// Three.js レンダリング用パラメータセット
export const common = {
    //このインデックスでparams配列から対象データを指定する
    targetIndex: 0,
    //targetIndex: 0,     //川口市グリーンセンター 3Dモデル＆360ツアー
    //targetIndex: 1,     //川口市グリーンセンター Matterport SDK
    //targetIndex: 2,     //Medtronic PL
    //targetIndex: 3,     //Medtronic PL40
    //targetIndex: 4,     //JAEC 2022 Winter
    //targetIndex: 5,     //IHI 2022 Winter
}

// アクセス時にポイントへ直接移動するクエリパラメータ
// 'index.html?skipmodels=true&domeno=186&angle=[0,-85,0]',  // mp1 大温室
// 'index.html?skipmodels=true&domeno=202&angle=[0,105,0]',  // mp2 大集会堂（シャトー赤柴）
// 'index.html?skipmodels=true&domeno=139&angle=[-5,112,0]',    // mp3 茶室

export const params = [
    //index=0: グリーンセンター全景
    {
        overall: {
            query: {
                enable: true,    //クエリパラメータで一部の入力値を上書きするか？
            },
            html: {
                title: 'Green Center 3D View'
            },
            renderer: {
                disable: false,
                sRGB: true,
                physicallyCorrectLights: false,
                toneMapping: 'None',
                shadowMap: false,
            },
            doAnimation: false,
            raycaster: {
                useRaycast: true,
            },
            axes: {
                enable: false,
                length: 100,
                position: [0, 15, 0],
            },
            grid: {
                enable: false,
                size: 800,
                divisions: 40,
                colorCenter: 0x333333,
                colorGrid: 0x333333,
                transparent: true,
                opacity: 0.2,
            }
        },
        debug: {
            level: 1,
            clearForProduction: true,
        },
        loader:{
            enable: true,
            loaderID:'loader',
            limitTime: 30.0,
        },
        navigation: {
            data: [
                {
                    name: 'logo',
                    type: 'link',
                    enable: false,
                    visible: false,
                    btnContainerID: 'header_ul',
                    btnID: 'logo',
                    btnClass: 'logo',
                    imageFile: 'img/logo_tanabotanical.png',
                    linkURL: 'https://www.tanabotanical.com/',
                },
                {
                    name: 'home',
                    type: 'link',
                    enable: true,
                    visible: true,
                    btnContainerID: 'header_ul',
                    btnID: 'home',
                    imageFile: 'img/360View/TOP_button_new.png',
                    linkURL: 'https://www.tanabotanical.com/',
                },
                {
                    name: 'message',
                    type: 'tag',
                    enable: false,
                    show: true,
                    visible: true,
                    btnContainerID: 'header_ul',
                    btnID: 'btn_tag1',  //'btn_'のあとを該当タグのgroupidと同一にすること
                    iconOnFile: 'img/btn_message_on.png',
                    iconOffFile: 'img/btn_message_off.png"',
                },
                {
                    name: 'map',
                    type: 'map',
                    subtype: 'entry',
                    enable: true,
                    show: false,
                    visible: false,
                    containerID: 'sidenav',
                    class: 'map2',
                    //mapID: 'map',
                    //imageFile: 'img/map.png',
                    imageAlt: 'マップ',
                    btnContainerID: 'header_ul',
                    btnID: 'map',
                    //iconOnFile: 'img/btn_map_on.png',
                    //iconOffFile: 'img/btn_map_off.png',
                    iconOnFile: 'img/360View/MAP_button_new.png',
                    iconOffFile: 'img/360View/MAP_button_new.png',
                    //マップパラメータ
                    mapIndex: 0,
                    mapData: [
                        [{
                            imageFile: 'img/360View/map/map_whole_S.png',
                            refPoints: { xdir: 'horizontal', offset: 0, p: { real: [226.4, -42.2], image: [57, 104] }, q: { real: [-195.5, 163.8], image: [210, 32] } },
                        }]
                    ],
                    //imageFile: 'img/360View/map/map_whole_S.png',
                    //refPoints: { xdir:'horizontal', offset:0, p: {real:[226.4, -42.2], image:[57,104]}, q:{ real:[-195.5, 163.8], image:[210,32]} },    //座標 P、Q (real:実座標、image:画像上の座標)
                    offsetAngle: 0.0,   //角度のオフセット
                    playerScale: { x: 32, z: 32 },     //ユーザ位置表示画像サイズ（px）
                    playerImageFile: 'img/360View/map/map_S_player_ctr.png',    //ユーザ位置表示用画像
                },
                {
                    name: 'info',
                    type: 'image',
                    enable: false,
                    visible: true,
                    containerID: 'overlay',
                    imageID: 'imagepanel',
                    btnContainerID: 'header_ul',
                    btnID: 'info',
                    iconOnFile: 'img/buttons/btn_help_on.png',
                    iconOffFile: 'img/buttons/btn_help_off.png"',
                    addTitle: false,
                    titleText: '川口市立グリーンセンター園内マップ',
                    imageFile: 'img/Tanabotanical/big-map5l.jpg',
                    addLink: true,
                    linkText: 'グリーンセンターHP',
                    linkURL: 'http://greencenter.1110city.com/map.html',
                    target: '_blank'
                },
                {
                    name: '3Dview',
                    type: 'sidelink',
                    enable: true,
                    visible: false,
                    css: {
                        class: 'exit_alt',
                    },
                    targetID: 'sidenav',
                    buttonImage: 'img/360View/3Dview_button_new.png',
                    function: 'url',   //'url':指定したurlへ 'back':呼び出し元へ（次のurlパラメータは無視）
                    urlIndex: 0,     //urls[]のどれを有効にするか (0のみ)
                    urls: [
                        'index.html'
                    ],
                    linkTarget: '_self',      //リンクターゲット'_self'または'_blank'。 'back'の場合は強制的に'_blank'にする
                },
                {
                    name: 'LocationList',
                    type: 'sidelink',
                    enable: true,
                    visible: true,
                    css: {
                        class: 'leftBtn',
                    },
                    targetID: 'sidenav',
                    buttonImage: 'img/3Dview/list.png',
                    function: 'none',   //'url':指定したurlへ 'back':呼び出し元へ（次のurlパラメータは無視）
                    urlIndex: 0,     //urls[]のどれを有効にするか
                    urls: [
                        'index.html'
                    ],
                    linkTarget: '_self',      //リンクターゲット'_self'または'_blank'。 'back'の場合は強制的に'_blank'にする
                }
            ]
        },
        camera: {
            initialIndex: 0,
            group: [
                {
                    name: '3DView',
                    position: [500, 500, 500],
                    lookAt: [0, 15, 0],
                    fov: 45,
                    near: 10.0,
                    far: 5000,
                    orbitControl: {
                        enable: true,
                        target: [0, 15, 0],
                        offset: [500, 500, 500],
                        enableZoom: true,
                        enablePan: true,
                        enableDamping: true,
                        dampingFactor: 0.3,
                        minDistance: 200,
                        maxDistance: 800,
                        minPolarAngle: Math.PI * 10 / 180,
                        maxPolarAngle: Math.PI / 2,
                        rotateSpeed: 0.5,
                        autoRotate: false,
                        autoRotateSpeed: -0.5,
                    }
                },
                {
                    name: '360 Virtual Tour',
                    position: [0, 0, -0.1],
                    lookAt: [0, 0, 0],
                    fov: 45,
                    near: 0.1,
                    far: 10000,
                    orbitControl: {
                        enable: true,
                        target: [0, 0, 0],
                        offset: [0, 0, -0.1],
                        enableZoom: true,
                        enablePan: false,
                        enableDamping: true,
                        dampingFactor: 0.3,
                        minDistance: 0.05,
                        maxDistance: 1,
                        minPolarAngle: 0.0,
                        maxPolarAngle: Math.PI,
                        rotateSpeed: -0.25,
                        autoRotate: false,
                        autoRotateSpeed: 2.0,
                    },
                },
            ]
        },
        lights: {
            ambient: [
                { color: 0xffffff, intensity: 1.5 },
            ],
            directional: [],
            hemisphere: [],
            point: [],
            spot: [],
            area: []

        },
        skybox: {
            enable: true,
            imageDir: 'img/3Dview/',
            image: '3Dview_BG.png',
            setEnvironmentMap: false,
        },
        environmentMap: {
            enable: true,
            imageDir: 'img/3Dview/',
            image: '3Dview_BG.png',
            useLightprobe: false,
        },
        domes: {
            enable: true,
            imageDir: 'img360/',
            color: 0xFFFFFF,
            sRGB: true,
            //dispose:true,
            marker: {
                draw: true,
                prefix: 'm',
                type: 'quad',
                size: 1.0,
                heightOffset: -1.4,
                rotation: [0, 0, 0],
                color: 0xCCFFFF,
                opacity: 0.7,
                focusFactor: 1.2,
                faceToCamera: true,
                imagedir: 'img/360View/',
                image: 'point.png',
            },
            zup: true,
            easeBase: 'Quartic',
            easeEnd: 'InOut',
            duration: 2000,
            moveToInitialLocation: false,
            initialImage: 'p049.jpg',
            changeCamera: true,  //ドーム入出時にカメラインデックスを変えるか？
            inCameraIndex: 1,    //ドームに入る際のカメラインデックス
            outCameraIndex: 0,   //ドームから出る際のカメラインデックス
            baseRadius: 500.0,
            baseRange: 150.0,
            spherePrefix: 'p',
            batchImportNum: 30,  //バッチ処理による１回の画像読み込み数
            widthSegments: 32,
            hightSegments: 16,
            initialConnects: [52, 172, 186, 189, 199],
            changeNavigation: true,
            enableNaviList: ['home', 'map', '3Dview'],  //表示するナビ（トップ＆サイド）メニュー
            debug: {
                rotateByKey: true,   //キー入力でドームを回転させる（角度合わせ用） 左右カーソルでnormalInc。ShiftでaltInc
                normalInc: 2.0, //キー押下時の角度増分（deg)
                altInc: 0.2,   //Shiftキー押下時の角度増分(deg)
                guide:{
                    enable:false,     //ガイド画像を表示するか？
                    position:[0,-1.0,0],   //ガイド画像の相対位置（カメラ位置基準）
                    rotation:[90,180,0],   //ガイド画像の角度
                    scale:3.0,      //ガイド画像のスケール
                    imagedir: 'img/360View/',
                    image:'guide.png'  //ガイド画像（ドーム中心に表示される）
                }   
            },
            spheres: [

                { omit:false ,visible:true,  image:'p024.jpg', radius:1.0, range:1.0, connect:[25,26], position:[-76.559 ,5.900, -59.278], rotation:[0.00, -190.80, 0.00] },
                { omit:false ,visible:true,  image:'p025.jpg', radius:1.0, range:1.0, connect:[24,26], position:[-85.389 ,5.900, -50.712], rotation:[0.00, -74.30, 0.00] },
                { omit:false ,visible:true,  image:'p026.jpg', radius:1.0, range:1.0, connect:[24,25,114], position:[-76.676 ,5.900, -46.879], rotation:[0.00, 173.30, 0.00] },
                { omit:false ,visible:true,  image:'p046.jpg', radius:1.0, range:1.0, connect:[47,164,184], position:[144.804 ,4.020, -98.654], rotation:[0.00, 172.00, 0.00] },
                { omit:false ,visible:true,  image:'p047.jpg', radius:1.0, range:1.0, connect:[46,48,52,163], position:[144.842 ,4.080, -86.036], rotation:[0.00, -170.60, 0.00] },
                { omit:false ,visible:true,  image:'p048.jpg', radius:1.0, range:1.0, connect:[47,49,52], position:[169.012 ,4.260, -78.462], rotation:[0.00, -76.80, 0.00] },
                { omit:false ,visible:true,  image:'p049.jpg', radius:1.0, range:1.0, connect:[48,50,52], position:[206.689 ,4.370, -66.070], rotation:[0.00, -15.50, 0.00] },
                { omit:false ,visible:true,  image:'p050.jpg', radius:1.0, range:1.0, connect:[49,52,53,60], position:[226.388 ,4.720, -42.232], rotation:[0.00, -81.20, 0.00] },
                
                { omit:false ,visible:true,  image:'p052.jpg', radius:1.0, range:1.0, connect:[47,49,50,60,61,72,73], position:[196.457 ,5.950, -25.210], rotation:[0.00, -54.80, 0.00] },
                { omit:false ,visible:true,  image:'p053.jpg', radius:1.0, range:1.0, connect:[50,54,60], position:[251.656 ,4.950, -34.671], rotation:[0.00, 2.30, 0.00] },
                { omit:false ,visible:true,  image:'p054.jpg', radius:1.0, range:1.0, connect:[53,55,58], position:[266.230 ,5.230, -15.953], rotation:[0.00, -50.70, 0.00] },
                { omit:false ,visible:true,  image:'p055.jpg', radius:1.0, range:1.0, connect:[54,56,58], position:[274.285 ,5.340, -2.020], rotation:[0.00, -18.30, 0.00] },
                { omit:false ,visible:true,  image:'p056.jpg', radius:1.0, range:1.0, connect:[55,57,58], position:[270.629 ,5.400, 10.625], rotation:[0.00, -29.30, 0.00] },
                { omit:false ,visible:true,  image:'p057.jpg', radius:1.0, range:1.0, connect:[56,234,59], position:[267.781 ,5.340, 23.855], rotation:[0.00, -18.70, 0.00] },
                { omit:false ,visible:true,  image:'p058.jpg', radius:1.0, range:1.0, connect:[54,55,56,59,61], position:[253.712 ,5.380, 3.585], rotation:[0.00, -111.60, 0.00] },
                { omit:false ,visible:true,  image:'p059.jpg', radius:1.0, range:1.0, connect:[57,61,62], position:[240.915 ,5.370, 12.484], rotation:[0.00, 157.20, 0.00] },
                { omit:false ,visible:true,  image:'p060.jpg', radius:1.0, range:1.0, connect:[50,52,61], position:[226.577 ,4.970, -15.640], rotation:[0.00, -133.90, 0.00] },
                { omit:false ,visible:true,  image:'p061.jpg', radius:1.0, range:1.0, connect:[59,60,62], position:[227.137 ,5.240, 3.963], rotation:[0.00, -117.90, 0.00] },
                { omit:false ,visible:true,  image:'p062.jpg', radius:1.0, range:1.0, connect:[61,64,69], position:[227.410 ,5.320, 22.816], rotation:[0.00, -49.60, 0.00] },
                { omit:false ,visible:true,  image:'p063.jpg', radius:1.0, range:1.0, connect:[64,65], position:[234.701 ,5.420, 37.068], rotation:[0.00, 25.20, 0.00] },
                { omit:false ,visible:true,  image:'p064.jpg', radius:1.0, range:1.0, connect:[62,63], position:[237.126 ,5.400, 30.863], rotation:[0.00, -39.30, 0.00] },
                { omit:false ,visible:true,  image:'p065.jpg', radius:1.0, range:1.0, connect:[63,67], position:[226.259 ,5.410, 48.779], rotation:[0.00, 2.40, 0.00] },
                { omit:false ,visible:true,  image:'p066.jpg', radius:1.0, range:1.0, connect:[67,68,210,213], position:[220.975 ,10.020, 79.464], rotation:[0.00, -24.40, 0.00] },
                { omit:false ,visible:true,  image:'p067.jpg', radius:1.0, range:1.0, connect:[65,66,68], position:[226.805 ,10.800, 70.867], rotation:[0.00, -38.50, 0.00] },
                { omit:false ,visible:true,  image:'p068.jpg', radius:1.0, range:1.0, connect:[66,67,210,212,213], position:[218.236 ,12.590, 89.134], rotation:[0.00, -7.80, 0.00] },
                { omit:false ,visible:true,  image:'p069.jpg', radius:1.0, range:1.0, connect:[62,70], position:[218.999 ,5.350, 36.503], rotation:[0.00, -54.00, 0.00] },
                { omit:false ,visible:true,  image:'p070.jpg', radius:1.0, range:1.0, connect:[69,71,224], position:[202.604 ,5.180, 45.524], rotation:[0.00, -25.70, 0.00] },
                { omit:false ,visible:true,  image:'p071.jpg', radius:1.0, range:1.0, connect:[70,72,145,224,225], position:[168.394 ,4.650, 37.969], rotation:[0.00, -27.60, 0.00] },
                { omit:false ,visible:true,  image:'p072.jpg', radius:1.0, range:1.0, connect:[52,71,73], position:[164.352 ,4.560, 19.262], rotation:[0.00, -61.50, 0.00] },
                { omit:false ,visible:true,  image:'p073.jpg', radius:1.0, range:1.0, connect:[52,72,163], position:[152.016 ,4.460, -16.887], rotation:[0.00, -49.60, 0.00] },
                { omit:false ,visible:true,  image:'p074.jpg', radius:1.0, range:1.0, connect:[], position:[146.801 ,4.480, -25.024], rotation:[0.00, -22.71, 0.00] },
                { omit:false ,visible:true,  image:'p075.jpg', radius:1.0, range:1.0, connect:[76,100], position:[-170.470 ,2.900, 44.562], rotation:[0.00, 119.70, 0.00] },
                { omit:false ,visible:true,  image:'p076.jpg', radius:1.0, range:1.0, connect:[75,77,103], position:[-131.837 ,3.330, 35.724], rotation:[0.00, 102.50, 0.00] },
                { omit:false ,visible:true,  image:'p077.jpg', radius:1.0, range:1.0, connect:[76,78], position:[-112.285 ,3.530, 26.111], rotation:[0.00, 55.80, 0.00] },
                { omit:false ,visible:true,  image:'p078.jpg', radius:1.0, range:1.0, connect:[77,83,111], position:[-102.546 ,3.880, 21.601], rotation:[0.00, 45.80, 0.00] },
                
                { omit:false ,visible:true,  image:'p080.jpg', radius:1.0, range:1.0, connect:[82,110], position:[-66.166 ,6.270, 36.721], rotation:[0.00, 102.60, 0.00] },
                { omit:false ,visible:true,  image:'p081.jpg', radius:1.0, range:1.0, connect:[], position:[-71.238 ,6.280, 39.121], rotation:[0.00, 178.84, 0.00] },
                { omit:false ,visible:true,  image:'p082.jpg', radius:1.0, range:1.0, connect:[80,110], position:[-79.448 ,6.030, 19.597], rotation:[0.00, 140.80, 0.00] },
                { omit:false ,visible:true,  image:'p083.jpg', radius:1.0, range:1.0, connect:[78,112,136], position:[-62.532 ,7.200, 4.524], rotation:[0.00, 57.30, 0.00] },
                { omit:false ,visible:true,  image:'p084.jpg', radius:1.0, range:1.0, connect:[85], position:[-96.924 ,7.540, 48.932], rotation:[0.00, -180.00, 0.00] },
                { omit:false ,visible:true,  image:'p085.jpg', radius:1.0, range:1.0, connect:[84,86,105], position:[-95.246 ,7.960, 59.843], rotation:[0.00, 92.40, 0.00] },
                { omit:false ,visible:true,  image:'p086.jpg', radius:1.0, range:1.0, connect:[85,98,104], position:[-105.484 ,7.340, 60.481], rotation:[0.00, 145.00, 0.00] },
                { omit:false ,visible:true,  image:'p087.jpg', radius:1.0, range:1.0, connect:[88,92], position:[-133.072 ,3.430, 7.430], rotation:[0.00, 116.90, 0.00] },
                { omit:false ,visible:true,  image:'p088.jpg', radius:1.0, range:1.0, connect:[87,90], position:[-150.736 ,3.210, 9.258], rotation:[0.00, 130.40, 0.00] },
                { omit:false ,visible:true,  image:'p089.jpg', radius:1.0, range:1.0, connect:[], position:[-162.672 ,3.010, 10.715], rotation:[0.00, 115.62, 0.00] },
                { omit:false ,visible:true,  image:'p090.jpg', radius:1.0, range:1.0, connect:[88], position:[-176.449 ,2.950, 12.812], rotation:[0.00, -117.40, 0.00] },
                { omit:false ,visible:true,  image:'p091.jpg', radius:1.0, range:1.0, connect:[90], position:[-208.039 ,2.370, 17.981], rotation:[0.00, -139.24, 0.00] },
                { omit:false ,visible:true,  image:'p092.jpg', radius:1.0, range:1.0, connect:[77,87,93], position:[-115.338 ,3.760, 5.602], rotation:[0.00, 61.60, 0.00] },
                { omit:false ,visible:true,  image:'p093.jpg', radius:1.0, range:1.0, connect:[92,94], position:[-117.206 ,4.060, -9.145], rotation:[0.00, -82.40, 0.00] },
                { omit:false ,visible:true,  image:'p094.jpg', radius:1.0, range:1.0, connect:[93,95], position:[-118.356 ,3.950, -17.854], rotation:[0.00, -67.80, 0.00] },
                { omit:false ,visible:true,  image:'p095.jpg', radius:1.0, range:1.0, connect:[94,96], position:[-119.215 ,3.880, -25.480], rotation:[0.00, -77.70, 0.00] },
                { omit:false ,visible:true,  image:'p096.jpg', radius:1.0, range:1.0, connect:[95,97], position:[-124.357 ,3.470, -67.728], rotation:[0.00, -70.50, 0.00] },
                { omit:false ,visible:true,  image:'p097.jpg', radius:1.0, range:1.0, connect:[96], position:[-127.038 ,3.200, -87.831], rotation:[0.00, -72.50, 0.00] },
                { omit:false ,visible:true,  image:'p098.jpg', radius:1.0, range:1.0, connect:[86,99], position:[-118.908 ,6.540, 58.446], rotation:[0.00, 34.20, 0.00] },
                { omit:false ,visible:true,  image:'p099.jpg', radius:1.0, range:1.0, connect:[98,102], position:[-132.994 ,5.780, 64.477], rotation:[0.00, 117.60, 0.00] },
                { omit:false ,visible:true,  image:'p100.jpg', radius:1.0, range:1.0, connect:[75,99], position:[-161.776 ,4.330, 66.764], rotation:[0.00, 78.80, 0.00] },
                
                { omit:false ,visible:true,  image:'p102.jpg', radius:1.0, range:1.0, connect:[99,100], position:[-145.614 ,5.130, 62.696], rotation:[0.00, 78.60, 0.00] },
                { omit:false ,visible:true,  image:'p103.jpg', radius:1.0, range:1.0, connect:[76,104], position:[-122.400 ,5.100, 49.252], rotation:[0.00, -134.20, 0.00] },
                { omit:false ,visible:true,  image:'p104.jpg', radius:1.0, range:1.0, connect:[86,103], position:[-109.985 ,6.780, 53.572], rotation:[0.00, -13.30, 0.00] },
                { omit:false ,visible:true,  image:'p105.jpg', radius:1.0, range:1.0, connect:[85,106], position:[-80.936 ,8.400, 63.894], rotation:[0.00, 53.00, 0.00] },
                { omit:false ,visible:true,  image:'p106.jpg', radius:1.0, range:1.0, connect:[105,107], position:[-74.555 ,7.640, 58.210], rotation:[0.00, -55.50, 0.00] },
                { omit:false ,visible:true,  image:'p107.jpg', radius:1.0, range:1.0, connect:[106,111,173], position:[-74.672 ,6.590, 50.826], rotation:[0.00, -42.20, 0.00] },
                { omit:false ,visible:true,  image:'p108.jpg', radius:1.0, range:1.0, connect:[109,161,235], position:[52.817 ,12.070, -38.722], rotation:[0.00, 43.60, 0.00] },
                { omit:false ,visible:true,  image:'p109.jpg', radius:1.0, range:1.0, connect:[108,156,154], position:[61.939 ,12.640, -32.214], rotation:[0.00, 56.50, 0.00] },
                { omit:false ,visible:true,  image:'p110.jpg', radius:1.0, range:1.0, connect:[82,111], position:[-86.343 ,4.500, 25.634], rotation:[0.00, 56.50, 0.00] },
                { omit:false ,visible:true,  image:'p111.jpg', radius:1.0, range:1.0, connect:[107,110,78], position:[-94.206 ,4.300, 28.450], rotation:[0.00, 112.60, 0.00] },
                { omit:false ,visible:true,  image:'p112.jpg', radius:1.0, range:1.0, connect:[83,113,127], position:[-80.094 ,5.470, -23.592], rotation:[0.00, 79.90, 0.00] },
                { omit:false ,visible:true,  image:'p113.jpg', radius:1.0, range:1.0, connect:[112,127,155], position:[-73.780 ,5.360, -33.500], rotation:[0.00, 51.60, 0.00] },
                { omit:false ,visible:true,  image:'p114.jpg', radius:1.0, range:1.0, connect:[26,115,155], position:[-68.274 ,5.600, -58.672], rotation:[0.00, -102.20, 0.00] },
                { omit:false ,visible:true,  image:'p115.jpg', radius:1.0, range:1.0, connect:[114,116,155], position:[-74.182 ,5.220, -69.822], rotation:[0.00, -25.50, 0.00] },
                { omit:false ,visible:true,  image:'p116.jpg', radius:1.0, range:1.0, connect:[115,117,118,155], position:[-54.982 ,5.070, -74.287], rotation:[0.00, -146.60, 0.00] },
                { omit:false ,visible:true,  image:'p117.jpg', radius:1.0, range:1.0, connect:[116,121], position:[-55.786 ,5.020, -79.713], rotation:[0.00, -113.00, 0.00] },
                { omit:false ,visible:true,  image:'p118.jpg', radius:1.0, range:1.0, connect:[117,119,124,155], position:[-41.195 ,4.640, -70.963], rotation:[0.00, -123.20, 0.00] },
                { omit:false ,visible:true,  image:'p119.jpg', radius:1.0, range:1.0, connect:[118,120,122], position:[-21.671 ,3.950, -76.901], rotation:[0.00, -103.40, 0.00] },
                { omit:false ,visible:true,  image:'p120.jpg', radius:1.0, range:1.0, connect:[119,121], position:[-25.145 ,3.430, -87.387], rotation:[0.00, 130.20, 0.00] },
                { omit:false ,visible:true,  image:'p121.jpg', radius:1.0, range:1.0, connect:[117,120], position:[-41.452 ,3.320, -90.400], rotation:[0.00, 70.50, 0.00] },
                { omit:false ,visible:true,  image:'p122.jpg', radius:1.0, range:1.0, connect:[119,123], position:[-3.584 ,3.590, -78.133], rotation:[0.00, -86.80, 0.00] },
                { omit:false ,visible:true,  image:'p123.jpg', radius:1.0, range:1.0, connect:[122,185,187,189], position:[15.754 ,3.540, -78.182], rotation:[0.00, 81.20, 0.00] },
                { omit:false ,visible:true,  image:'p124.jpg', radius:1.0, range:1.0, connect:[118,125,133], position:[-33.832 ,6.020, -61.574], rotation:[0.00, -52.00, 0.00] },
                { omit:false ,visible:true,  image:'p125.jpg', radius:1.0, range:1.0, connect:[124,126,135], position:[-52.325 ,5.920, -44.827], rotation:[0.00, -4.20, 0.00] },
                { omit:false ,visible:true,  image:'p126.jpg', radius:1.0, range:1.0, connect:[113,125,135], position:[-60.731 ,6.110, -33.365], rotation:[0.00, 100.00, 0.00] },
                { omit:false ,visible:true,  image:'p127.jpg', radius:1.0, range:1.0, connect:[112,113,125,126], position:[-64.702 ,6.240, -28.451], rotation:[0.00, -68.50, 0.00] },
                { omit:false ,visible:true,  image:'p128.jpg', radius:1.0, range:1.0, connect:[127,129,135,83], position:[-59.091 ,6.920, -13.804], rotation:[0.00, 139.00, 0.00] },
                { omit:false ,visible:true,  image:'p129.jpg', radius:1.0, range:1.0, connect:[128,130,135,136], position:[-42.497 ,8.000, -19.864], rotation:[0.00, 120.90, 0.00] },
                { omit:false ,visible:true,  image:'p130.jpg', radius:1.0, range:1.0, connect:[129,131,134], position:[-33.616 ,8.420, -24.786], rotation:[0.00, 117.80, 0.00] },
                { omit:false ,visible:true,  image:'p131.jpg', radius:1.0, range:1.0, connect:[130,132,137], position:[-25.899 ,9.450, -22.071], rotation:[0.00, 20.30, 0.00] },
                { omit:false ,visible:true,  image:'p132.jpg', radius:1.0, range:1.0, connect:[131,133], position:[-20.975 ,10.450, -33.341], rotation:[0.00, -205.50, 0.00] },
                { omit:false ,visible:true,  image:'p133.jpg', radius:1.0, range:1.0, connect:[132,130,124], position:[-32.569 ,7.750, -40.503], rotation:[0.00, 7.50, 0.00] },
                { omit:false ,visible:true,  image:'p134.jpg', radius:1.0, range:1.0, connect:[129,130,132,133], position:[-33.752 ,8.120, -32.084], rotation:[0.00, -7.20, 0.00] },
                { omit:false ,visible:true,  image:'p135.jpg', radius:1.0, range:1.0, connect:[126,128,129], position:[-50.503 ,7.180, -25.975], rotation:[0.00, -0.90, 0.00] },
                { omit:false ,visible:true,  image:'p136.jpg', radius:1.0, range:1.0, connect:[83,137,200,129], position:[-49.011 ,8.550, 2.171], rotation:[0.00, 68.80, 0.00] },
                { omit:false ,visible:true,  image:'p137.jpg', radius:1.0, range:1.0, connect:[131,136,201,202,162], position:[-15.206 ,11.420, -11.926], rotation:[0.00, 49.10, 0.00] },
                { omit:false ,visible:true,  image:'p138.jpg', radius:1.0, range:1.0, connect:[141,154,160], position:[58.510 ,12.700, 11.832], rotation:[0.00, -124.10, 0.00] },
                { omit:false ,visible:true,  image:'p139.jpg', radius:1.0, range:1.0, connect:[159,160], position:[78.256 ,12.890, -0.656], rotation:[0.00, -147.30, 0.00] },
                { omit:false ,visible:true,  image:'p140.jpg', radius:1.0, range:1.0, connect:[139], position:[83.813 ,12.780, -2.773], rotation:[0.00, 42.79, 0.00] },
                { omit:false ,visible:true,  image:'p141.jpg', radius:1.0, range:1.0, connect:[138,142], position:[55.954 ,11.020, 53.898], rotation:[0.00, 146.90, 0.00] },
                { omit:false ,visible:true,  image:'p142.jpg', radius:1.0, range:1.0, connect:[141,143], position:[88.296 ,6.640, 108.318], rotation:[0.00, -44.70, 0.00] },
                { omit:false ,visible:true,  image:'p143.jpg', radius:1.0, range:1.0, connect:[142,144,152], position:[114.040 ,6.060, 113.798], rotation:[0.00, -131.40, 0.00] },
                { omit:false ,visible:true,  image:'p144.jpg', radius:1.0, range:1.0, connect:[143,145], position:[136.667 ,5.200, 89.200], rotation:[0.00, -90.80, 0.00] },
                { omit:false ,visible:true,  image:'p145.jpg', radius:1.0, range:1.0, connect:[144,146,71,225], position:[158.842 ,4.770, 62.839], rotation:[0.00, 10.20, 0.00] },
                { omit:false ,visible:true,  image:'p146.jpg', radius:1.0, range:1.0, connect:[145,148], position:[162.492 ,5.200, 69.257], rotation:[0.00, -51.60, 0.00] },
                { omit:false ,visible:true,  image:'p147.jpg', radius:1.0, range:1.0, connect:[145,146,148,227,228,229,230,231], position:[160.432 ,5.390, 78.533], rotation:[0.00, 81.54, 0.00] },
                { omit:false ,visible:true,  image:'p148.jpg', radius:1.0, range:1.0, connect:[146,149,232], position:[161.442 ,5.740, 94.248], rotation:[0.00, 46.30, 0.00] },
                { omit:false ,visible:true,  image:'p149.jpg', radius:1.0, range:1.0, connect:[148,150,232], position:[158.857 ,6.240, 111.311], rotation:[0.00, -6.10, 0.00] },
                { omit:false ,visible:true,  image:'p150.jpg', radius:1.0, range:1.0, connect:[144,147,148,149,151,152], position:[150.005 ,6.170, 114.933], rotation:[0.00, 88.20, 0.00] },
                { omit:false ,visible:true,  image:'p151.jpg', radius:1.0, range:1.0, connect:[152,149], position:[146.416 ,6.510, 119.896], rotation:[0.00, -80.40, 0.00] },
                { omit:false ,visible:true,  image:'p152.jpg', radius:1.0, range:1.0, connect:[151,153], position:[139.025 ,6.690, 126.859], rotation:[0.00, -4.20, 0.00] },
                { omit:false ,visible:true,  image:'p153.jpg', radius:1.0, range:1.0, connect:[142,143,144,152], position:[116.579 ,6.170, 120.218], rotation:[0.00, -162.60, 0.00] },
                { omit:false ,visible:true,  image:'p154.jpg', radius:1.0, range:1.0, connect:[109,138,161], position:[60.653 ,13.110, -16.379], rotation:[0.00, 157.60, 0.00] },
                { omit:false ,visible:true,  image:'p155.jpg', radius:1.0, range:1.0, connect:[113,114,115,116,118], position:[-53.096 ,4.990, -61.892], rotation:[0.00, -95.00, 0.00] },
                { omit:false ,visible:true,  image:'p156.jpg', radius:1.0, range:1.0, connect:[109,157], position:[66.291 ,12.700, -32.977], rotation:[0.00, 79.20, 0.00] },
                { omit:false ,visible:true,  image:'p157.jpg', radius:1.0, range:1.0, connect:[156,158,159], position:[74.179 ,13.900, -22.703], rotation:[0.00, 107.30, 0.00] },
                
                { omit:false ,visible:true,  image:'p159.jpg', radius:1.0, range:1.0, connect:[139,157], position:[72.213 ,13.760, -14.049], rotation:[0.00, -87.00, 0.00] },
                { omit:false ,visible:true,  image:'p160.jpg', radius:1.0, range:1.0, connect:[138,139,159], position:[66.824 ,13.050, 3.494], rotation:[0.00, 41.70, 0.00] },
                { omit:false ,visible:true,  image:'p161.jpg', radius:1.0, range:1.0, connect:[108,154,162], position:[36.296 ,12.850, -32.814], rotation:[0.00, 55.90, 0.00] },
                { omit:false ,visible:true,  image:'p162.jpg', radius:1.0, range:1.0, connect:[137,161], position:[9.657 ,12.560, -33.302], rotation:[0.00, 147.80, 0.00] },
                { omit:false ,visible:true,  image:'p163.jpg', radius:1.0, range:1.0, connect:[73,47,183], position:[129.299 ,4.180, -57.033], rotation:[0.00, 21.50, 0.00] },
                { omit:false ,visible:true,  image:'p164.jpg', radius:1.0, range:1.0, connect:[46], position:[151.589 ,3.930, -117.671], rotation:[0.00, -97.90, 0.00] },
                { omit:false ,visible:true,  image:'p165.jpg', radius:1.0, range:1.0, connect:[166,167,169], position:[-26.013 ,9.740, 172.811], rotation:[0.00, -81.03, 0.00] },
                { omit:false ,visible:true,  image:'p166.jpg', radius:1.0, range:1.0, connect:[165], position:[-16.265 ,12.900, 171.610], rotation:[0.00, 178.60, 0.00] },
                { omit:false ,visible:true,  image:'p167.jpg', radius:1.0, range:1.0, connect:[165,168,169], position:[-50.452 ,6.890, 161.098], rotation:[0.00, -101.30, 0.00] },
                { omit:false ,visible:true,  image:'p168.jpg', radius:1.0, range:1.0, connect:[167,170,171], position:[-45.323 ,9.710, 135.676], rotation:[0.00, -89.40, 0.00] },
                { omit:false ,visible:true,  image:'p169.jpg', radius:1.0, range:1.0, connect:[165,167,170,181,206,207], position:[-60.952 ,6.740, 179.145], rotation:[0.00, -174.90, 0.00] },
                { omit:false ,visible:true,  image:'p170.jpg', radius:1.0, range:1.0, connect:[168,169,171,172,175], position:[-67.503 ,6.460, 141.687], rotation:[0.00, 27.10, 0.00] },
                { omit:false ,visible:true,  image:'p171.jpg', radius:1.0, range:1.0, connect:[170,172,168], position:[-60.622 ,6.550, 109.198], rotation:[0.00, -92.00, 0.00] },
                { omit:false ,visible:true,  image:'p172.jpg', radius:1.0, range:1.0, connect:[170,171,173,175,176], position:[-67.886 ,6.390, 100.301], rotation:[0.00, -1.60, 0.00] },
                { omit:false ,visible:true,  image:'p173.jpg', radius:1.0, range:1.0, connect:[107,172], position:[-66.924 ,6.000, 71.952], rotation:[0.00, 54.60, 0.00] },
                { omit:false ,visible:true,  image:'p174.jpg', radius:1.0, range:1.0, connect:[175,192,180,177,178,179,195,204,205], position:[-142.243 ,6.810, 137.791], rotation:[0.00, 27.00, 0.00] },
                { omit:false ,visible:true,  image:'p175.jpg', radius:1.0, range:1.0, connect:[170,172,174,205], position:[-100.473 ,23.500, 141.639], rotation:[0.00, 140.09, 0.00] },
                { omit:false ,visible:true,  image:'p176.jpg', radius:1.0, range:1.0, connect:[172,177], position:[-86.063 ,6.130, 92.235], rotation:[0.00, 96.80, 0.00] },
                { omit:false ,visible:true,  image:'p177.jpg', radius:1.0, range:1.0, connect:[174,176,178], position:[-128.345 ,5.650, 93.345], rotation:[0.00, 163.60, 0.00] },
                { omit:false ,visible:true,  image:'p178.jpg', radius:1.0, range:1.0, connect:[174,177,179,180], position:[-154.565 ,5.450, 94.525], rotation:[0.00, -91.90, 0.00] },
                { omit:false ,visible:true,  image:'p179.jpg', radius:1.0, range:1.0, connect:[174,178,180], position:[-172.675 ,5.300, 98.611], rotation:[0.00, 0.87, 0.00] },
                { omit:false ,visible:true,  image:'p180.jpg', radius:1.0, range:1.0, connect:[174,178,179,192,175], position:[-181.256 ,5.160, 101.345], rotation:[0.00, 14.10, 0.00] },                { omit:false ,visible:true,  image:'p181.jpg', radius:1.0, range:1.0, connect:[206,182], position:[-86.215 ,6.240, 205.900], rotation:[0.00, -158.00, 0.00] },
                { omit:false ,visible:true,  image:'p181.jpg', radius:1.0, range:1.0, connect:[206,182], position:[-86.215 ,6.240, 205.900], rotation:[0.00, -158.00, 0.00] },
                { omit:false ,visible:true,  image:'p182.jpg', radius:1.0, range:1.0, connect:[181], position:[-99.572 ,5.320, 222.066], rotation:[0.00, -98.35, 0.00] },
                { omit:false ,visible:true,  image:'p183.jpg', radius:1.0, range:1.0, connect:[163,184,185], position:[97.126 ,4.220, -63.387], rotation:[0.00, -85.10, 0.00] },
                { omit:false ,visible:true,  image:'p184.jpg', radius:1.0, range:1.0, connect:[46,183,185,188], position:[115.530 ,3.630, -101.721], rotation:[0.00, 175.90, 0.00] },
                { omit:false ,visible:true,  image:'p185.jpg', radius:1.0, range:1.0, connect:[183,184,186,188,189], position:[77.673 ,3.600, -104.861], rotation:[0.00, -94.10, 0.00] },
                { omit:false ,visible:true,  image:'p186.jpg', radius:1.0, range:1.0, connect:[185,187,188,189], position:[22.780 ,3.200, -109.208], rotation:[0.00, -80.40, 0.00] },
                { omit:false ,visible:true,  image:'p187.jpg', radius:1.0, range:1.0, connect:[186,189,123], position:[12.592 ,3.350, -94.838], rotation:[0.00, -104.60, 0.00] },
                { omit:false ,visible:true,  image:'p188.jpg', radius:1.0, range:1.0, connect:[184,185,186], position:[84.358 ,3.850, -129.766], rotation:[0.00, -23.37, 0.00] },
                { omit:false ,visible:true,  image:'p189.jpg', radius:1.0, range:1.0, connect:[123,185,186,187,209], position:[57.200 ,3.670, -89.886], rotation:[0.00, 12.40, 0.00] },
                
                { omit:false ,visible:true,  image:'p192.jpg', radius:1.0, range:1.0, connect:[174,180,193,175], position:[-181.234 ,5.170, 131.394], rotation:[0.00, -9.60, 0.00] },
                { omit:false ,visible:true,  image:'p193.jpg', radius:1.0, range:1.0, connect:[192,194,175], position:[-198.508 ,5.300, 163.783], rotation:[0.00, -209.80, 0.00] },
                { omit:false ,visible:true,  image:'p194.jpg', radius:1.0, range:1.0, connect:[193,195,175], position:[-183.606 ,5.610, 177.271], rotation:[0.00, -154.40, 0.00] },
                { omit:false ,visible:true,  image:'p195.jpg', radius:1.0, range:1.0, connect:[174,194,203], position:[-147.810 ,5.760, 186.027], rotation:[0.00, -145.70, 0.00] },               
                { omit:false ,visible:true,  image:'p198.jpg', radius:1.0, range:1.0, connect:[199,201,202], position:[-2.523 ,11.530, 43.173], rotation:[0.00, 105.90, 0.00] },
                { omit:false ,visible:true,  image:'p199.jpg', radius:1.0, range:1.0, connect:[198,200,201,202], position:[-20.657 ,10.850, 26.198], rotation:[0.00, 26.00, 0.00] },
                { omit:false ,visible:true,  image:'p200.jpg', radius:1.0, range:1.0, connect:[136,199], position:[-45.904 ,9.700, 16.267], rotation:[0.00, 73.90, 0.00] },
                { omit:false ,visible:true,  image:'p201.jpg', radius:1.0, range:1.0, connect:[137,198,199,202], position:[-2.626 ,11.630, 21.038], rotation:[0.00, 50.60, 0.00] },
                { omit:false ,visible:true,  image:'p202.jpg', radius:1.0, range:1.0, connect:[137,198,199,201], position:[6.199 ,13.270, 18.672], rotation:[0.00, 31.50, 0.00] },
                { omit:false ,visible:true,  image:'p203.jpg', radius:1.0, range:1.0, connect:[195,204,206], position:[-126.774 ,5.870, 187.795], rotation:[0.00, 85.60, 0.00] },
                { omit:false ,visible:true,  image:'p204.jpg', radius:1.0, range:1.0, connect:[174,203,205], position:[-118.264 ,6.440, 173.834], rotation:[0.00, 53.74, 0.00] },
                { omit:false ,visible:true,  image:'p205.jpg', radius:1.0, range:1.0, connect:[174,204,207], position:[-102.537 ,6.980, 170.515], rotation:[0.00, 98.10, 0.00] },
                { omit:false ,visible:true,  image:'p206.jpg', radius:1.0, range:1.0, connect:[169,181,203], position:[-81.709 ,6.400, 188.687], rotation:[0.00, -17.90, 0.00] },
                { omit:false ,visible:true,  image:'p207.jpg', radius:1.0, range:1.0, connect:[169,205,208], position:[-76.776 ,6.120, 170.699], rotation:[0.00, 124.90, 0.00] },
                { omit:false ,visible:true,  image:'p208.jpg', radius:1.0, range:1.0, connect:[204,206,207], position:[-91.566 ,6.550, 179.233], rotation:[0.00, 122.00, 0.00] },
                { omit:false ,visible:true,  image:'p209.jpg', radius:1.0, range:1.0, connect:[189,235], position:[55.394 ,2.930, -68.714], rotation:[0.00, 72.30, 0.00] },
                { omit:false ,visible:true,  image:'p210.jpg', radius:1.0, range:1.0, connect:[66,68,211,233], position:[239.763 ,9.890, 78.707], rotation:[0.00, -88.00, 0.00] },
                { omit:false ,visible:true,  image:'p211.jpg', radius:1.0, range:1.0, connect:[210,212], position:[231.326 ,10.320, 93.805], rotation:[0.00, -23.00, 0.00] },
                { omit:false ,visible:true,  image:'p212.jpg', radius:1.0, range:1.0, connect:[68,211,213,214], position:[214.183 ,10.200, 95.894], rotation:[0.00, 40.60, 0.00] },
                { omit:false ,visible:true,  image:'p213.jpg', radius:1.0, range:1.0, connect:[66,68,212,214,218], position:[202.560 ,10.050, 84.050], rotation:[0.00, 47.00, 0.00] },
                { omit:false ,visible:true,  image:'p214.jpg', radius:1.0, range:1.0, connect:[212,213,216,218], position:[201.289 ,10.010, 94.785], rotation:[0.00, -179.10, 0.00] },
                { omit:false ,visible:true,  image:'p215.jpg', radius:1.0, range:1.0, connect:[214,216], position:[199.868 ,10.190, 104.497], rotation:[0.00, -153.89, 0.00] },
                { omit:false ,visible:true,  image:'p216.jpg', radius:1.0, range:1.0, connect:[214,215,217,218], position:[193.915 ,10.110, 100.041], rotation:[0.00, -68.74, 0.00] },
                { omit:false ,visible:true,  image:'p217.jpg', radius:1.0, range:1.0, connect:[216,218,232], position:[186.255 ,10.400, 103.019], rotation:[0.00, 30.80, 0.00] },
                { omit:false ,visible:true,  image:'p218.jpg', radius:1.0, range:1.0, connect:[213,214,216,217,219], position:[193.103 ,9.980, 91.295], rotation:[0.00, -48.50, 0.00] },
                { omit:false ,visible:true,  image:'p219.jpg', radius:1.0, range:1.0, connect:[218,220,230], position:[184.202 ,9.220, 86.835], rotation:[0.00, -14.90, 0.00] },
                { omit:false ,visible:true,  image:'p220.jpg', radius:1.0, range:1.0, connect:[219,222], position:[186.077 ,9.020, 81.872], rotation:[0.00, 7.80, 0.00] },
                { omit:false ,visible:true,  image:'p221.jpg', radius:1.0, range:1.0, connect:[220,222], position:[186.100 ,8.050, 76.639], rotation:[0.00, 58.39, 0.00] },
                { omit:false ,visible:true,  image:'p222.jpg', radius:1.0, range:1.0, connect:[220,223], position:[187.604 ,6.700, 72.360], rotation:[0.00, 35.40, 0.00] },
                { omit:false ,visible:true,  image:'p223.jpg', radius:1.0, range:1.0, connect:[222,224,225], position:[190.338 ,5.850, 68.935], rotation:[0.00, -173.70, 0.00] },
                { omit:false ,visible:true,  image:'p224.jpg', radius:1.0, range:1.0, connect:[70,71,223,225,226], position:[182.835 ,5.140, 53.528], rotation:[0.00, 116.50, 0.00] },
                { omit:false ,visible:true,  image:'p225.jpg', radius:1.0, range:1.0, connect:[71,145,223,224,226], position:[174.910 ,5.730, 52.647], rotation:[0.00, 150.90, 0.00] },
                { omit:false ,visible:true,  image:'p226.jpg', radius:1.0, range:1.0, connect:[224,225,229], position:[176.821 ,6.450, 65.901], rotation:[0.00, 139.00, 0.00] },
                { omit:false ,visible:true,  image:'p227.jpg', radius:1.0, range:1.0, connect:[226,228], position:[177.447 ,6.590, 69.789], rotation:[0.00, 150.80, 0.00] },
                { omit:false ,visible:true,  image:'p228.jpg', radius:1.0, range:1.0, connect:[226,229], position:[180.361 ,6.900, 72.709], rotation:[0.00, 161.96, 0.00] },
                { omit:false ,visible:true,  image:'p229.jpg', radius:1.0, range:1.0, connect:[226,230], position:[179.797 ,7.710, 77.301], rotation:[0.00, 139.40, 0.00] },
                { omit:false ,visible:true,  image:'p230.jpg', radius:1.0, range:1.0, connect:[219,229,232], position:[180.870 ,8.560, 86.455], rotation:[0.00, -105.10, 0.00] },
                { omit:false ,visible:true,  image:'p231.jpg', radius:1.0, range:1.0, connect:[219,230,232], position:[181.313 ,7.380, 92.972], rotation:[0.00, 116.50, 0.00] },
                { omit:false ,visible:true,  image:'p232.jpg', radius:1.0, range:1.0, connect:[217,230,148,149], position:[176.498 ,6.850, 101.800], rotation:[0.00, 78.80, 0.00] },
                { omit:false ,visible:true,  image:'p233.jpg', radius:1.0, range:1.0, connect:[210,234], position:[253.381 ,8.200, 64.742], rotation:[0.00, -73.10, 0.00] },
                { omit:false ,visible:true,  image:'p234.jpg', radius:1.0, range:1.0, connect:[57,233], position:[260.526 ,6.750, 43.875], rotation:[0.00, -57.10, 0.00] },
                { omit:false ,visible:true,  image:'p235.jpg', radius:1.0, range:1.0, connect:[108,209], position:[53.226 ,12.130, -43.950], rotation:[0.00, 126.10, 0.00] },

            ],
        },
        billboard2D: [
            //HTML/CSSフォーマットのタグーパネル
            {
                groupid: 'grass',
                enable: true,
                prefix: 'billplant',
                tagcommon: {
                    draw: true,
                    action: 'openimage',
                    imagedir: 'img/360View/',
                    image: 'tag_plant.png',
                    scale: [1, 1, 1],
                    focusFactor: 1.2,
                    color: 0xCCCCCC,
                    faceToCamera: true,
                },
                imagecommon: {
                    containerID: 'overlay',
                    imageID: 'plant',
                    imagedir: 'img/360View/plant/',
                    addlink: true,
                    target: '_blank',
                    addTitle: false,
                    css: {
                        class: 'popupmod',
                    },
                    closeButton: {
                        enable: true,
                        action: 'close',
                        dir: 'img/360View/plant/',
                        image: '360_plant_close.png',
                        css: {
                            class: 'close2D',
                        }
                    },
                    linkButton: {
                        enable: false,
                        css: {
                            class: '',
                        }
                    },
                },
                debug: {
                    moveByKey: false,   //キー入力でタグを移動する  [w/s/a/d]または前後左右キーで平面移動、Shift+[e/q]で高さ移動.ShiftでaltInc
                    normalInc: 0.2, //キー押下時の位置増分（m)
                    altInc: 1.0,   //Optionキー押下時の位置増分(m)
                },
                data: [

                    {load:true, name:'plant01', moveToDome:true, dome:'p123.jpg', hide: true, showImage: false, connect:[123,122], pos:[2.55 , 2.54 , -69.78], image:{image:'360_plant_1.png', addTitle:false, titleText:'カタクリ'}, link:{type:'none'}},
                    {load:true, name:'plant02', moveToDome:true, dome:'p122.jpg', hide: true, showImage: false, connect:[122,119,123], pos:[-7.18 , 2.99 , -74.93], image:{image:'360_plant_2.png', addTitle:false, titleText:'シモバシラ'}, link:{type:'none'}},
                    {load:true, name:'plant03', moveToDome:true, dome:'p123.jpg', hide: true, showImage: false, connect:[123,122,186,187], pos:[21.75 , 4.34 , -79.98], image:{image:'360_plant_3.png', addTitle:false, titleText:'ハナミズキ'}, link:{type:'none'}},
                    {load:true, name:'plant04', moveToDome:true, dome:'p154.jpg', hide: true, showImage: false, connect:[154,138], pos:[66.54 , 15.00 , -15.80 ], image:{image:'360_plant_4.png', addTitle:false, titleText:'カエデ類'}, link:{type:'none'}},
                    {load:true, name:'plant05', moveToDome:true, dome:'p189.jpg', hide: true, showImage: false, connect:[189,185,186,187], pos:[41.20 , 2.60 , -94.89], image:{image:'360_plant_5.png', addTitle:false, titleText:'チューリップ'}, link:{type:'none'}},
                    {load:true, name:'plant06', moveToDome:true, dome:'p124.jpg', hide: true, showImage: false, connect:[124,118,125], pos:[-30.23 , 7.22 , -50.17 ], image:{image:'360_plant_6.png', addTitle:false, titleText:'アセビ'}, link:{type:'none'}},
                    {load:true, name:'plant07', moveToDome:true, dome:'p046.jpg', hide: true, showImage: false, connect:[46,47,164], pos:[138.40 , 4.02 , -114.25], image:{image:'360_plant_7.png', addTitle:false, titleText:'サラサウツギ'}, link:{type:'none'}},
                    {load:true, name:'plant08', moveToDome:true, dome:'p048.jpg', hide: true, showImage: false, connect:[48,47], pos:[184.41 , 4.26 , -85.86], image:{image:'360_plant_8.png', addTitle:false, titleText:'マンサク'}, link:{type:'none'}},
                    {load:true, name:'plant09', moveToDome:true, dome:'p048.jpg', hide: true, showImage: false, connect:[48,47], pos:[179.81 , 4.26 , -89.46], image:{image:'360_plant_9.png', addTitle:false, titleText:'タラヨウ'}, link:{type:'none'}},
                    {load:true, name:'plant10', moveToDome:true, dome:'p163.jpg', hide: true, showImage: false, connect:[163,73,47], pos:[131.70 , 5.78 , -45.23 ], image:{image:'360_plant_10.png', addTitle:false, titleText:'エゴノキ'}, link:{type:'none'}},
                    {load:true, name:'plant11', moveToDome:true, dome:'p050.jpg', hide: true, showImage: false, connect:[50,49,52], pos:[225.39 , 4.72 , -60.03], image:{image:'360_plant_11.png', addTitle:false, titleText:'サルスベリ'}, link:{type:'none'}},
                    {load:true, name:'plant12', moveToDome:true, dome:'p055.jpg', hide: true, showImage: false, connect:[55,54,56,58], pos:[278.29 , 5.74 , -3.82 ], image:{image:'360_plant_12.png', addTitle:false, titleText:'クリ'}, link:{type:'none'}},
                    {load:true, name:'plant13', moveToDome:true, dome:'p218.jpg', hide: true, showImage: false, connect:[218,213,214,216,219], pos:[197.10 , 8.58 , 88.89], image:{image:'360_plant_13.png', addTitle:false, titleText:'フジバカマ'}, link:{type:'none'}},
                    {load:true, name:'plant14', moveToDome:true, dome:'p146.jpg', hide: true, showImage: false, connect:[146,145,148], pos:[176.49 , 7.00 , 76.46], image:{image:'360_plant_14.png', addTitle:false, titleText:'エノキ'}, link:{type:'none'}},
                    {load:true, name:'plant15', moveToDome:true, dome:'p145.jpg', hide: true, showImage: false, connect:[145,144,71], pos:[122.60 , 5.30 , 66.20], image:{image:'360_plant_15.png', addTitle:false, titleText:'ハンカチノキ'}, link:{type:'none'}},
                    {load:true, name:'plant16', moveToDome:true, dome:'p145.jpg', hide: true, showImage: false, connect:[145,144], pos:[128.20 , 6.20 , 64.80], image:{image:'360_plant_16.png', addTitle:false, titleText:'ナギ'}, link:{type:'none'}},
                    {load:true, name:'plant17', moveToDome:true, dome:'p145.jpg', hide: true, showImage: false, connect:[145,144,71], pos:[124.60 , 5.80 , 48.60], image:{image:'360_plant_17.png', addTitle:false, titleText:'ハス'}, link:{type:'none'}},
                    {load:true, name:'plant18', moveToDome:true, dome:'p149.jpg', hide: true, showImage: false, connect:[149,148,232], pos:[167.42 , 6.51 , 110.30 ], image:{image:'360_plant_18.png', addTitle:false, titleText:'アジサイ'}, link:{type:'none'}},  
                    {load:true, name:'plant19', moveToDome:true, dome:'p143.jpg', hide: true, showImage: false, connect:[143,], pos:[108.24 , 8.0, 104.60 ], image:{image:'360_plant_19.png', addTitle:false, titleText:'キンメイチク'}, link:{type:'none'}},
                    {load:true, name:'plant20', moveToDome:true, dome:'p133.jpg', hide: true, showImage: false, connect:[133,132,130], pos:[-27.57 , 7.75 , -35.50], image:{image:'360_plant_20.png', addTitle:false, titleText:'アガパンサス'}, link:{type:'none'}},
                    {load:true, name:'plant21', moveToDome:true, dome:'p123.jpg', hide: true, showImage: false, connect:[123,122], pos:[6.35 , 3.94 , -67.98], image:{image:'360_plant_21.png', addTitle:false, titleText:'ヒガンバナ'}, link:{type:'none'}},
                    {load:true, name:'plant22', moveToDome:true, dome:'p163.jpg', hide: true, showImage: false, connect:[163,183], pos:[123.30 , 3.38 , -55.23], image:{image:'360_plant_22.png', addTitle:false, titleText:'テッポウユリ'}, link:{type:'none'}},
                    {load:true, name:'plant23', moveToDome:true, dome:'p135.jpg', hide: true, showImage: false, connect:[135,126,128], pos:[-56.90 , 5.98 , -26.77], image:{image:'360_plant_23.png', addTitle:false, titleText:'ボタン'}, link:{type:'none'}},
                    {load:true, name:'plant24', moveToDome:true, dome:'p124.jpg', hide: true, showImage: false, connect:[124,118,125,133], pos:[-28.43 , 8.62 , -56.57], image:{image:'360_plant_24.png', addTitle:false, titleText:'モクレン'}, link:{type:'none'}},
                    {load:true, name:'plant25', moveToDome:true, dome:'p200.jpg', hide: true, showImage: false, connect:[200,199], pos:[-36.90 , 9.10 , 14.47], image:{image:'360_plant_25.png', addTitle:false, titleText:'バラ'}, link:{type:'none'}},
                    {load:true, name:'plant26', moveToDome:true, dome:'p169.jpg', hide: true, showImage: false, connect:[169,207], pos:[-66.15 , 8.34 , 182.15], image:{image:'360_plant_26.png', addTitle:false, titleText:'ヒイラギ'}, link:{type:'none'}},
                    {load:true, name:'plant27', moveToDome:true, dome:'p195.jpg', hide: true, showImage: false, connect:[195,194], pos:[-155.21 , 7.76 , 181.83], image:{image:'360_plant_27.png', addTitle:false, titleText:'マテバシイ'}, link:{type:'none'}},
                    {load:true, name:'plant28', moveToDome:true, dome:'p192.jpg', hide: true, showImage: false, connect:[192,174,180,193], pos:[-177.83 , 6.17 , 141.99], image:{image:'360_plant_28.png', addTitle:false, titleText:'ケヤキ'}, link:{type:'none'}},
                    {load:true, name:'plant29', moveToDome:true, dome:'p171.jpg', hide: true, showImage: false, connect:[171,170,172], pos:[-62.44 , 9.00 , 118.59], image:{image:'360_plant_29.png', addTitle:false, titleText:'アンギョウカンザクラ'}, link:{type:'none'}},
                    {load:true, name:'plant30', moveToDome:true, dome:'p176.jpg', hide: true, showImage: false, connect:[176,172], pos:[-89.06 , 8.53 , 96.83], image:{image:'360_plant_30.png', addTitle:false, titleText:'モミジバスズカケノキ'}, link:{type:'none'}},
                    {load:true, name:'plant31', moveToDome:true, dome:'p078.jpg', hide: true, showImage: false, connect:[78,77,83,111], pos:[ -92.55 , 10.8 , 9.80], image:{image:'360_plant_31.png', addTitle:false, titleText:'ダイオウショウ'}, link:{type:'none'}},
                    {load:true, name:'plant32', moveToDome:true, dome:'p119.jpg', hide: true, showImage: false, connect:[119,118,120,122], pos:[-26.67 , 3.95 , -71.10], image:{image:'360_plant_32.png', addTitle:false, titleText:'サザンカ'}, link:{type:'none'}},
                    {load:true, name:'plant33', moveToDome:true, dome:'p076.jpg', hide: true, showImage: false, connect:[76,77,84,85,103,104], pos:[ -113.04 , 7.00 , 41.92], image:{image:'360_plant_33.png', addTitle:false, titleText:'ウメ'}, link:{type:'none'}},

                ],
            },
            {
                groupid: 'architecture',
                enable: true,
                prefix: 'billarch',
                tagcommon: {
                    draw: true,
                    action: 'openimage',
                    imagedir: 'img/360View/',
                    image: 'tag_building.png',
                    scale: [2, 2, 2],
                    focusFactor: 1.2,
                    color: 0xCCCCCC,
                    faceToCamera: true,
                },
                imagecommon: {
                    containerID: 'overlay',
                    imageID: 'architecture',
                    imagedir: 'img/360View/building/',
                    addlink: true,
                    target: '_blank',
                    addTitle: false,
                    css: {
                        class: 'popupmod',
                    },
                    closeButton: {
                        enable: true,
                        action: 'close',
                        dir: 'img/360View/building/',
                        image: 'building_close_new.png',
                        css: {
                            class: 'close2D',
                        }
                    },
                    linkButton: {
                        enable: true,    //各dataにlinkURLを指定すること
                        action: 'gotolink',
                        linkTarget: '_self',
                        dir: 'img/360View/building/',
                        image: 'building_ENTER_new.png',
                        css: {
                            class: '',
                        }
                    }
                },
                debug: {
                    moveByKey: false,   //キー入力でタグを移動する
                    normalInc: 1.0, //キー押下時の位置増分（m)
                    altInc: 0.2,   //Ctrlキー押下時の位置増分(m)
                },
                data: [
                    {
                        load: true,
                        name: 'a01',    //大温室
                        target: '_blank',
                        moveToDome: false,
                        dome: 'p186.jpg',
                        hide: true,
                        showImage: false,
                        connect: [186, 187],
                        pos: [2, 7.5, -108],
                        image: {
                            image: 'building_daionshitsu.png',    //仮に茶室の画像を適用
                            addTitle: false,
                            titleText: '',
                        },
                        link: {
                            type: 'image',
                            image: 'building_ENTER_new.png',
                            URL: 'index_mp1.html',
                        },
                    },
                    {
                        load: true,
                        name: 'a02',    //集会堂
                        //linkURL: 'https://my.matterport.com/show/?m=idXyYHZ9TLw',
                        target: '_blank',
                        moveToDome: false,
                        dome: 'p202.jpg',
                        hide: true,
                        showImage: false,
                        connect: [199, 201, 202],
                        pos: [15, 14.50, 16.2],
                        image: {
                            image: 'building_assemblyhall.png',
                            addTitle: false,
                            titleText: '',
                        },
                        link: {
                            type: 'image',
                            image: 'building_ENTER_new.png',
                            URL: 'index_mp2.html',
                        },
                    },
                    {
                        load: true,
                        name: 'a02a',    //集会堂その２
                        //linkURL: 'https://my.matterport.com/show/?m=idXyYHZ9TLw',
                        target: '_blank',
                        moveToDome: false,
                        dome: 'p154.jpg',
                        hide: true,
                        showImage: false,
                        connect: [154],
                        pos: [45.0 ,13.110, -13.0],
                        image: {
                            image: 'building_assemblyhall.png',
                            addTitle: false,
                            titleText: '',
                        },
                        link: {
                            type: 'image',
                            image: 'building_ENTER_new.png',
                            URL: 'index_mp2a.html',
                        },
                    },
                    {
                        load: true,
                        name: 'a03',    //茶室
                        //linkURL: 'https://my.matterport.com/show/?m=spdGVyiShX5',
                        target: '_blank',
                        moveToDome: false,
                        dome: 'p139.jpg',
                        hide: true,
                        showImage: false,
                        connect: [139],
                        pos: [87, 12.5, -4],
                        image: {
                            image: 'building_chashitsu.png',
                            addTitle: false,
                            titleText: '',
                        },
                        link: {
                            type: 'image',
                            image: 'building_ENTER_new.png',
                            URL: 'index_mp3.html',
                        },
                    }
                ],
            }

        ],
        billboards: [
        ],
        models: [
            {
                groupid: 'base',
                enable: true,
                modelDir: 'models/',
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                tagConnect: false,
                data: [
                    {
                        load: true,
                        visible: true,
                        //name: 'gc20220619_1024k.glb',
                        //name: 'gc20220830_1024k.glb',
                        //name: 'gc20220830_512k.glb',
                        //name: 'gc20220830_512k_c10.glb', //0910 CX確認版
                        //name: 'gc20220830_512k_c10.fbx',
                        //name: 'gc20220830_512k_c10c3.glb',
                        name: 'gc20220913_512px_c10.glb',
                        useDRACO: false,
                        position: [0, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1, 1, 1],
                        animation: {
                            enable: true,
                            rotSpeed: [0.0, -0.001, 0.0]
                        }
                    },
                ],
            }
        ],
        tags: [
            {
                groupid: 'tag1',
                enable: true,
                prefix: 't',
                imageDir: 'img/3Dview/',
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                faceTagToCamera: true,
                initiallyOn: true,
                clickAction: true,
                actionType: 'GoToDome',
                data: [
                    {
                        load: true,
                        name: 'onshitsu',
                        image: 'daionshitsu.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        imageposition: [-15, 75, -105],
                        footposition: [-15, 0, -105],
                        rotation: [0, 0, 0],
                        scale: [30, 30, 30],
                        actionParam: { name: 'p186.jpg', angle: [0, -85, 0], distance: 1.0 },
                    },
                    {
                        load: true,
                        name: 'shibafu',
                        image: 'shibafuhiroba.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        imageposition: [185, 75, -25],
                        footposition: [185, 0, -25],
                        rotation: [0, 0, 0],
                        scale: [30, 30, 30],
                        actionParam: { name: 'p052.jpg', angle: [0, 55, 0], distance: 1.0 },
                    },
                    {
                        load: true,
                        name: 'akashiba',
                        image: 'daisyukaidou.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        imageposition: [22, 75, 20],
                        footposition: [22, 0, 20],
                        rotation: [0, 0, 0],
                        scale: [30, 30, 30],
                        actionParam: { name: 'p199.jpg', angle: [0, 110, 0], distance: 1.0 },
                    },
                    {
                        load: true,
                        name: 'kadan',
                        image: 'kadanhiroba.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        imageposition: [60, 75, -100],
                        footposition: [60, 0, -100],
                        rotation: [0, 0, 0],
                        scale: [30, 30, 30],
                        actionParam: { name: 'p189.jpg', angle: [0, 0, 0], distance: 1.0 },
                    },
                    {
                        load: true,
                        name: 'wanpaku',
                        image: 'wanpakuhiroba.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        imageposition: [-120, 75, 120],
                        footposition: [-120, 0, 120],
                        rotation: [0, 0, 0],
                        scale: [30, 30, 30],
                        actionParam: { name: 'p172.jpg', angle: [0, 15, 0], distance: 1.0 },
                    },
                ]
            }
        ],
        gui: {
            enable: false,
            title: 'Input',
            width: 310,
            groups: [
                {
                    category: 'Rendering',
                    open: true,
                    items: [
                        { name: 'Visible', value: true },
                    ]
                },
                {
                    category: 'OrbitRotation',
                    open: true,
                    items: [
                        { name: 'Direction', value: ['CW', 'CCW', 'NONE'] },
                        { name: 'Speed', value: 1.0, range: [0, 3.0] },
                    ]
                },
            ]
        }
    },
    //index=1: Matterport SDK
    {
        // Matterportスペースに応じて、次の値を変更する     0:大温室 1:大集会室 2:茶室
        // navigation-type:'map' の mapIndex=0 or 1 or 2 or 3 (imagefile & refpoints)
        // navigation-type:'sidelink' のurlIndex=0 or 1 or 2 or 3(urlsのどの要素を有効にするか？)
        // matterport の mpIndex=0 or 1 or 2 or 3(spaceID & startParamを指定）
        overall: {
            query: {
                enable: false,
            },
            html: {
                title: 'Green Center 3D View'
            },
            renderer: {
                disable: true,  //Matterport SDK使用するためレンダラーを明示的に作成しない。
                sRGB: true,
                physicallyCorrectLights: false,
                toneMapping: 'None',
                shadowMap: false,
            },
            doAnimation: false,
            raycaster: {
                useRaycast: true,
            },
            axes: {
                enable: false,
                length: 100,
                position: [0, 15, 0],
            },
            grid: {
                enable: false,
                size: 800,
                divisions: 40,
                colorCenter: 0x333333,
                colorGrid: 0x333333,
                transparent: true,
                opacity: 0.2,
            }
        },
        debug: {
            level: 1,
            clearForProduction: true,
        },
        loader:{
            enable: true,
            loaderID:'loader',
            limitTime: 3.0,
        },
        navigation: {
            data: [
                {
                    type: 'link',
                    enable: false,
                    visible: false,
                    btnContainerID: 'header_ul',
                    btnID: 'logo',
                    btnClass: 'logo',
                    imageFile: 'img/logo_tanabotanical.png',
                    linkURL: 'https://www.tanabotanical.com/',
                },
                {
                    type: 'link',
                    enable: true,
                    visible: true,
                    btnContainerID: 'header_ul',
                    btnID: 'home',
                    imageFile: 'img/360View/TOP_button_new.png',
                    linkURL: 'https://www.tanabotanical.com/',
                },
                {
                    type: 'map',
                    subtype: 'entry',
                    enable: true,
                    show: false,
                    visible: true,
                    containerID: 'sidenav',
                    class: 'map2a',
                    //mapID: 'map',
                    imageAlt: 'マップ',
                    btnContainerID: 'header_ul',
                    btnID: 'map',
                    iconOnFile: 'img/360View/MAP_button_new.png',
                    iconOffFile: 'img/360View/MAP_button_new.png',
                    //マップパラメータ
                    mapIndex: 3,    //mapData[]のどれを有効にするか    0:大温室 1:大集会室 2:茶室
                    mapData: [
                        [{   // mp1 大温室
                            imageFile: 'img/360View/map/map_S.png',
                            refPoints: { xdir: 'horizontal', offset: 180, p: { real: [45.78, -30.42], image: [70, 115] }, q: { real: [0.69, -7.16], image: [203, 46] } },
                        }],
                        [
                            {   // mp2 大集会堂（シャトー赤柴）1F
                                imageFile: 'img/360View/map/map_hall_1F_S.png',
                                refPoints: { xdir: 'vertical', offset: -90, p: { real: [-11.56, 22.10], image: [219, 132] }, q: { real: [5.63, -14.56], image: [82, 62] } },
                            },
                            {   // mp2 大集会堂（シャトー赤柴）2F
                                imageFile: 'img/360View/map/map_hall_2F_S.png',
                                refPoints: { xdir: 'vertical', offset: -90, p: { real: [-11.56, 22.10], image: [219, 132] }, q: { real: [5.63, -14.56], image: [82, 62] } },
                            }
                        ],
                        [{   // mp3 茶室
                            imageFile: 'img/360View/map/map_tearoom_S.png',
                            refPoints: { xdir: 'horizontal', offset: 0, p: { real: [36.525, -18.525], image: [150, 131] }, q: { real: [32.50, -27.82], image: [102, 21] } },
                        }],
                        [
                            {   // mp2 大集会堂（シャトー赤柴）1F
                                imageFile: 'img/360View/map/map_hall_1F_S.png',
                                refPoints: { xdir: 'vertical', offset: -90, p: { real: [-11.56, 22.10], image: [219, 132] }, q: { real: [5.63, -14.56], image: [82, 62] } },
                            },
                            {   // mp2 大集会堂（シャトー赤柴）2F
                                imageFile: 'img/360View/map/map_hall_2F_S.png',
                                refPoints: { xdir: 'vertical', offset: -90, p: { real: [-11.56, 22.10], image: [219, 132] }, q: { real: [5.63, -14.56], image: [82, 62] } },
                            }
                        ]
                    ],
                    offsetAngle: 0.0,   //角度のオフセット
                    playerScale: { x: 32, z: 32 },     //ユーザ位置表示画像サイズ（px）
                    playerImageFile: 'img/360View/map/map_S_player_ctr.png',    //ユーザ位置表示用画像
                },
                {
                    type: 'image',
                    enable: false,
                    show: false,
                    visible: true,
                    containerID: 'overlay',
                    imageID: 'imagepanel',
                    btnContainerID: 'header_ul',
                    btnID: 'info',
                    iconOnFile: 'img/btn_help_on.png',
                    iconOffFile: 'img/btn_help_off.png"',
                    addTitle: false,
                    titleText: '川口市立グリーンセンター園内マップ',
                    imageFile: 'img/big-map5l.jpg',
                    addLink: true,
                    linkText: 'グリーンセンターHP',
                    linkURL: 'http://greencenter.1110city.com/map.html',
                    target: '_blank'
                },
                {
                    type: 'tag',
                    enable: false,
                },

                {
                    type: 'sidelink',
                    enable: true,
                    visible: true,
                    css: {
                        class: 'exit',
                    },
                    targetID: 'sidenav',
                    buttonImage: 'img/360View/building_EXIT_button_new.png',
                    function: 'url',   //'url':指定したurlへ 'back':呼び出し元へ（次のurlパラメータは無視）
                    urlIndex: 3,      //urls[]のどれを有効にするか    0:大温室 1:大集会室 2:茶室 3:大集会室その２ 
                    urls: [
                        'index.html?skipmodels=true&domeno=186&angle=[0,-85,0]',  // mp1 大温室
                        'index.html?skipmodels=true&domeno=202&angle=[0,105,0]',  // mp2 大集会堂（シャトー赤柴）
                        'index.html?skipmodels=true&domeno=139&angle=[-5,112,0]',    // mp3 茶室
                        'index.html?skipmodels=true&domeno=154&angle=[0,-80,0]',  // mp2a 大集会堂その２（シャトー赤柴）
                        'index.html',
                    ],
                    linkTarget: '_self',      //リンクターゲット'_self'または'_blank'。 'back'の場合は強制的に'_blank'にする
                }
            ]
        },
        camera: {
            initialIndex: 0,
            group: [
                {
                    name: 'SubCamera',
                    position: [500, 500, 500],
                    lookAt: [0, 15, 0],
                    fov: 45,
                    near: 10.0,
                    far: 5000,
                    orbitControl: {
                        enable: false,
                    }
                }
            ]
        },
        lights: {
            ambient: [
                { color: 0xffffff, intensity: 1.5 },
            ],
            directional: [],
            hemisphere: [],
            point: [],
            spot: [],
            area: []
        },
        skybox: {
            enable: false,
        },
        environmentMap: {
            enable: false,
        },
        matterport: {
            enable: true,
            containerID: 'showcase',
            //key: 'knby2fi56zncgf41q6yir73tb',  //IHI Virtual Tour
            key: '2527fp0png0irnqci21uhspud', //tanabotanical.com
            queryParam: 'hl=2&play=1&qs=0&title=0&dh=1&gt=0&hr=0&brand=0&mt=1&newtags=1',    //newtagsを追加
            //queryParam: 'play=1&qs=0&title=0&brand=0',

            mpIndex: 3, //mpDataで使用するもののインデックス
            mpData: [
                //{ spaceID: 'mLyeJtCxq6Z', startParam: 'sr=-1.61,1.35&ss=108' },   // mp1 川口グリーンセンター 大温室   https://my.matterport.com/show/?m=mLyeJtCxq6Z
                { spaceID: 'z7nyGXM7P8y', startParam: 'sr=-1.61,1.35&ss=108' },   // mp1 川口グリーンセンター 大温室  複製版(2023/2/6) https://my.matterport.com/show/?m=z7nyGXM7P8y
                //{ spaceID: 'idXyYHZ9TLw', startParam: 'sr=-.3,-1.36&ss=99' },   // mp2 川口グリーンセンター シャトー赤柴（旧版：屋内ロビー）    https://my.matterport.com/show/?m=idXyYHZ9TLw
                { spaceID: 'idXyYHZ9TLw', startParam: 'sr=.89,-1.54&ss=22' },   // mp2 川口グリーンセンター シャトー赤柴（新版：外庭）    https://my.matterport.com/show/?m=idXyYHZ9TLw&sr=.89,-1.54&ss=22
                { spaceID: 'spdGVyiShX5', startParam: 'sr=.16,-1.33&ss=87' },     // mp3 川口グリーンセンター シャトー茶室    https://my.matterport.com/show/?m=spdGVyiShX5
                { spaceID: 'idXyYHZ9TLw', startParam: 'sr=-3.12,1.02&ss=57' },   // mp2 川口グリーンセンター シャトー赤柴（新版：外庭）    https://my.matterport.com/show/?m=idXyYHZ9TLw&sr=-3.12,1.02&ss=57
            ],
            // mp1 川口グリーンセンター 大温室   https://my.matterport.com/show/?m=mLyeJtCxq6Z
            //   複製版(2023/2/6) https://my.matterport.com/show/?m=z7nyGXM7P8y
            //    spaceID: 'mLyeJtCxq6Z',     
            //    startParam: 'sr=-1.61,1.35&ss=108', //開始点の座標・角度
            // mp2 川口グリーンセンター シャトー赤柴    https://my.matterport.com/show/?m=idXyYHZ9TLw
            //    spaceID: 'idXyYHZ9TLw',
            //    startParam: 'sr=-.3,-1.36&ss=99', //開始点の座標・角度
            // mp3 川口グリーンセンター シャトー茶室    https://my.matterport.com/show/?m=spdGVyiShX5
            //    spaceID: 'spdGVyiShX5',
            //    startParam: 'sr=.16,-1.33&ss=87', //開始点の座標・角度

            billboards: {
                enable: false,
                iconData:[
                    {name:'plant', data:'../img/360View/tag_plant.png'},
                    {name:'building', data:'../img/360View/tag_building.png'},
                ],
                iconName:'plant',
                index:0,
            }

        },
        domes: {
            enable: false,
        },
        billboards: [
            {
                enable: false,
            }
        ],
        models: [
            {
                groupid: 'base',
                enable: false,
                modelDir: 'models/',
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                tagConnect: false,
                data: [
                    {
                        load: false,
                        visible: true,
                        name: 'gc20220913_512px_c10.glb',
                        useDRACO: false,
                        position: [0, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1, 1, 1],
                        animation: {
                            enable: true,
                            rotSpeed: [0.0, -0.001, 0.0]
                        }
                    },
                ],
            }
        ],
        tags: [
            {
                enable: false,
            }
        ],
        gui: {
            enable: false,
        }
    },

    // index=2: モデルビューワー PL
    {
        overall: {
            query: {
                enable: false,
            },
            html: {
                title: 'Catalyft PL'
            },
            renderer: {
                disable: false,
                sRGB: true,
                physicallyCorrectLights: true,
                //toneMapping: 'ACESFilmic',
                toneMapping: 'None',
                shadowMap: true,
                clearColor: 0xFFFFFF,
                clearAlpha: 1.0,
            },
            scene: {
                bgColor: 0xFFFFFF,
            },
            doAnimation: false,
            raycaster: {
                useRaycast: true,
                markerPrefix: 'm',
            },
            axes: {
                enable: false,
                length: 100,
                position: [0, 0, 0],
            },
            grid: {
                enable: false,
                size: 200,
                divisions: 40,
                colorCenter: 0xF5F5F5,
                colorGrid: 0xF5F5F5,
                transparent: true,
                opacity: 0.4,
            }
        },
        debug: {
            level: 1,
            clearForProduction: false,
        },
        navigation: {
            data: [
                {
                    type: 'link',
                    enable: true,
                    btnContainerID: 'header_ul',
                    btnID: 'logo',
                    btnClass: 'logoPL',
                    imageFile: 'img/Medtronic/logo_medtronic_bl.png',
                    linkURL: '#',
                },
                {
                    type: 'image',
                    enable: true,
                    show: false,
                    containerID: 'overlay',
                    imageID: 'imagepanel',
                    btnContainerID: 'header_ul',
                    btnID: 'btn_size',
                    iconOnFile: 'img/Medtronic/btn_sizelist_b.png',
                    iconOffFile: 'img/Medtronic/btn_sizelist_w.png"',
                    addTitle: false,
                    titleText: 'Size Table',
                    imageFile: 'img/Medtronic/pl-table.png',
                    imageLink: false,
                },
                {
                    type: 'image',
                    enable: true,
                    show: false,
                    containerID: 'overlay',
                    imageID: 'imagepanel2',
                    btnContainerID: 'header_ul',
                    btnID: 'btn_proc',
                    iconOnFile: 'img/Medtronic/btn_procedure_b.png',
                    iconOffFile: 'img/Medtronic/btn_procedure_w.png"',
                    addTitle: false,
                    titleText: 'Catalyft<sup>TM</sup> PL',
                    imageFile: 'img/Medtronic/catalyft-pl.png',
                    imageLink: false,
                },
                {
                    type: 'tag',
                    enable: true,
                    show: false,
                    btnContainerID: 'header_ul',
                    btnID: 'btn_tag1',
                    iconOnFile: 'img/Medtronic/btn_notes_b.png',
                    iconOffFile: 'img/Medtronic/btn_notes_w.png',
                },
                {
                    type: 'side',
                    enable: true,
                    id: 'side1',
                    targetID: 'sidenav',
                    buttonPrev: 'img/Medtronic/section_left_collapse.png',
                    buttonNext: 'img/Medtronic/section_right_expand.png',
                },
            ]
        },
        camera: {
            initialIndex: 0,
            group: [
                {
                    name: 'PL',
                    position: [20, 10, -20],
                    lookAt: [0, 0, 0],
                    fov: 45,
                    near: 1.0,
                    far: 10000,
                    orbitControl: {
                        enable: true,
                        target: [0, 0, 0],
                        offset: [40, 40, -40],
                        enableZoom: true,
                        enablePan: false,
                        enableDamping: true,
                        dampingFactor: 0.08,
                        minDistance: 20,
                        maxDistance: 300,
                        minPolarAngle: 0.0,
                        maxPolarAngle: Math.PI,
                        autoRotate: false,
                        autoRotateSpeed: 1.0,
                    },
                }
            ]
        },
        lights: {
            ambient: [
                { color: 0xffffff, intensity: 10.0 }
            ],
            hemisphere: [
                //{skycolor:0xffffff, goundcolor:0xff00ff, intensity:5.0}
            ],
            directional: [
                { color: 0xffffff, intensity: 2.0, position: [10, 5, 10], castShadow: false, showHelper: false },
                { color: 0xffffff, intensity: 2.0, position: [-20, 10, 20], castShadow: false, showHelper: false },
                { color: 0xffffff, intensity: 2.0, position: [5, 0, -10], castShadow: false, showHelper: false },
                { color: 0xffffff, intensity: 2.0, position: [-5, -10, -20], castShadow: false, showHelper: false },
                { color: 0xffffff, intensity: 2.0, position: [20, 0, 0], castShadow: false, showHelper: false }
            ],
            //point:[{color:0xffffff, intensity:30.0, distance:20, position: [10,5,10], showHelper:false}],
            point: [
                //{color:0xffffff, intensity:30.0, distance:20, position: [15,0,0], showHelper:false},
                //{color:0xffffff, intensity:30.0, distance:20, position: [-15,5,0], showHelper:false},
                //{color:0xffffff, intensity:30.0, distance:20, position: [0,5,10], showHelper:false},
                //{color:0xffffff, intensity:30.0, distance:20, position: [0,5,-10], showHelper:false},
            ],
            spot: [
                //{color:0xffffff, intensity:30.0, distance:30, angle:60, exponent:10, position: [20,0,0], castShadow:true, showHelper:true},
            ],
            area: [
                //{color:0xffffff, intensity:30.0, width:1.0, height:1.0, position: [0,0,0], rotation:[0,0,0]}
            ]
        },
        skybox: {
            enable: false,
            imageDir: 'img/skybox/',
            //image: 'electricblue.png',
            image: 'white.png',
            setEnvironmentMap: true,
        },
        environmentMap: {
            enable: true,
            imageDir: 'img/skybox/',
            image: 'white.png',
            useLightprobe: false,
        },
        domes: {
            enable: false,
        },
        billboards: [
            {
                enable: false,
            }
        ],
        models: [
            {
                groupid: 'PL',
                enable: true,
                modelDir: 'models/Medtronic/',
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                tagConnect: true,
                data: [
                    {
                        load: true,
                        visible: true,
                        name: '6068073_0.glb',
                        useDRACO: false,
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'tag1',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6068073_2-75.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6068073_5-5.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6068073_8-25.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6068073_11.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6068073_13-75.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6068073_16-5.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6068073_19-25.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6068073_22.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                ]
            }
        ],
        tags: [
            {
                groupid: 'tag1',
                enable: true,
                imageDir: 'img/Medtronic/tags/',
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                faceTagToCamera: true,
                initiallyOn: false,
                clickAction: false,
                actionType: 'None',
                data: [
                    {
                        load: true,
                        name: 'pltag1',
                        image: 'pltag1a.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        linewidth: 2,
                        imageposition: [-14, 15, 0],
                        footposition: [-7, 8.5, 0],
                        rotation: [0, 0, 0],
                        scale: [12, 3, 1],
                    },
                    {
                        load: true,
                        name: 'pltag2',
                        image: 'pltag2a.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        linewidth: 2,
                        imageposition: [3, 15, -10],
                        footposition: [2, 8.5, -3],
                        rotation: [0, 0, 0],
                        scale: [12, 3, 1],
                    },
                    {
                        load: true,
                        name: 'pltag3',
                        image: 'pltag3a.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        linewidth: 2,
                        imageposition: [7, 15, 10],
                        footposition: [3, 8.5, 3],
                        rotation: [0, 0, 0],
                        scale: [12, 3, 1],
                    },
                    {
                        load: true,
                        name: 'pltag3t',
                        image: 'transparent16px.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        linewidth: 2,
                        imageposition: [7, 15, 10],
                        footposition: [9.5, 8, 0],
                        rotation: [0, 0, 0],
                        scale: [12, 3, 1],
                    },
                    {
                        load: true,
                        name: 'pltag4',
                        image: 'pltag4a.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        linewidth: 2,
                        imageposition: [14, 12, -7],
                        footposition: [12.5, 6.7, -3.8],
                        rotation: [0, 0, 0],
                        scale: [12, 3, 1],
                    },
                ]
            }
        ],
        gui: {
            enable: true,
            hide: true,
            title: 'GUI',
            width: 240,
            groups: [
                {
                    folder: false,
                    category: 'Input',
                    open: true,
                    items: [
                        //{ name: 'Type', value: { PL: 0, PL40: 1 } },
                        //{name:'Configuration', value:{'Close':0, '5.5deg':1, '11deg':2, '16.5deg':3, 'Open':4}},
                        { name: 'Angle', value: 0, range: [0, 22, 2.75] },
                        //{name:'Opacity', value:1, range:[0, 1, 0.02]},
                        //{ name: 'Direction', value: ['CW', 'CCW', 'NONE'] },
                    ]
                },
            ]
        }
    },

    // index=3: モデルビューワー PL40
    {
        overall: {
            query: {
                enable: false,
            },
            html: {
                title: 'Catalyft PL40'
            },
            renderer: {
                disable: false,
                sRGB: true,
                physicallyCorrectLights: true,
                //toneMapping: 'ACESFilmic',
                toneMapping: 'None',
                shadowMap: true,
                clearColor: 0xFFFFFF,
                clearAlpha: 1.0,
            },
            scene: {
                bgColor: 0xFFFFFF,
            },
            doAnimation: false,
            raycaster: {
                useRaycast: true,
                markerPrefix: 'm',
                tagPrefix: 't',
            },
            axes: {
                enable: false,
                length: 100,
                position: [0, 0, 0],
            },
            grid: {
                enable: false,
                size: 200,
                divisions: 40,
                colorCenter: 0xF5F5F5,
                colorGrid: 0xF5F5F5,
                transparent: true,
                opacity: 0.4,
            }
        },
        debug: {
            level: 1,
            clearForProduction: false,
        },
        navigation: {
            data: [
                {
                    type: 'link',
                    enable: true,
                    btnContainerID: 'header_ul',
                    btnID: 'logo',
                    btnClass: 'logoPL',
                    imageFile: 'img/Medtronic/logo_medtronic_bl.png',
                    linkURL: '#',
                },
                {
                    type: 'image',
                    enable: true,
                    show: false,
                    containerID: 'overlay',
                    imageID: 'imagepanel',
                    btnContainerID: 'header_ul',
                    btnID: 'btn_size',
                    iconOnFile: 'img/Medtronic/btn_sizelist_b.png',
                    iconOffFile: 'img/Medtronic/btn_sizelist_w.png"',
                    addTitle: false,
                    titleText: 'Size Table',
                    imageFile: 'img/Medtronic/pl-table.png',
                    imageLink: false,
                },
                {
                    type: 'image',
                    enable: true,
                    show: false,
                    containerID: 'overlay',
                    imageID: 'imagepanel2',
                    btnContainerID: 'header_ul',
                    btnID: 'btn_proc',
                    iconOnFile: 'img/Medtronic/btn_procedure_b.png',
                    iconOffFile: 'img/Medtronic/btn_procedure_w.png"',
                    addTitle: false,
                    titleText: 'Catalyft<sup>TM</sup> PL',
                    imageFile: 'img/Medtronic/catalyft-pl.png',
                    imageLink: false,
                },
                {
                    type: 'tag',
                    enable: true,
                    show: false,
                    btnContainerID: 'header_ul',
                    btnID: 'btn_tag1',
                    iconOnFile: 'img/Medtronic/btn_notes_b.png',
                    iconOffFile: 'img/Medtronic/btn_notes_w.png',
                },
                {
                    type: 'side',
                    enable: true,
                    id: 'side1',
                    targetID: 'sidenav',
                    buttonPrev: 'img/Medtronic/section_left_collapse.png',
                    buttonNext: 'img/Medtronic/section_right_expand.png',
                }
            ]
        },

        camera: {
            initialIndex: 0,
            group: [
                {
                    name: 'PL40',
                    position: [20, 10, -20],
                    lookAt: [0, 0, 0],
                    fov: 45,
                    near: 1.0,
                    far: 10000,
                    orbitControl: {
                        enable: true,
                        target: [0, 0, 0],
                        offset: [40, 40, -40],
                        enableZoom: true,
                        enablePan: false,
                        enableDamping: true,
                        dampingFactor: 0.08,
                        minDistance: 20,
                        maxDistance: 300,
                        minPolarAngle: 0.0,
                        maxPolarAngle: Math.PI,
                        autoRotate: false,
                        autoRotateSpeed: 1.0,
                    },
                }
            ]
        },
        lights: {
            ambient: [
                { color: 0xffffff, intensity: 10.0 }
            ],
            hemisphere: [
                //{skycolor:0xffffff, goundcolor:0xff00ff, intensity:5.0}
            ],
            directional: [
                { color: 0xffffff, intensity: 2.0, position: [10, 5, 10], castShadow: false, showHelper: false },
                { color: 0xffffff, intensity: 2.0, position: [-20, 10, 20], castShadow: false, showHelper: false },
                { color: 0xffffff, intensity: 2.0, position: [5, 0, -10], castShadow: false, showHelper: false },
                { color: 0xffffff, intensity: 2.0, position: [-5, -10, -20], castShadow: false, showHelper: false },
                { color: 0xffffff, intensity: 2.0, position: [20, 0, 0], castShadow: false, showHelper: false }
            ],
            //point:[{color:0xffffff, intensity:30.0, distance:20, position: [10,5,10], showHelper:false}],
            point: [
                //{color:0xffffff, intensity:30.0, distance:20, position: [15,0,0], showHelper:false},
                //{color:0xffffff, intensity:30.0, distance:20, position: [-15,5,0], showHelper:false},
                //{color:0xffffff, intensity:30.0, distance:20, position: [0,5,10], showHelper:false},
                //{color:0xffffff, intensity:30.0, distance:20, position: [0,5,-10], showHelper:false},
            ],
            spot: [
                //{color:0xffffff, intensity:30.0, distance:30, angle:60, exponent:10, position: [20,0,0], castShadow:true, showHelper:true},
            ],
            area: [
                //{color:0xffffff, intensity:30.0, width:1.0, height:1.0, position: [0,0,0], rotation:[0,0,0]}
            ]
        },
        skybox: {
            enable: false,
            imageDir: 'img/skybox/',
            image: 'white.png',
            setEnvironmentMap: true,
        },
        environmentMap: {
            enable: true,
            imageDir: 'img/skybox/',
            image: 'white.png',
            useLightprobe: false,
        },
        domes: {
            enable: false,
        },
        billboards: [
            {
                enable: false,
            }
        ],
        models: [
            {
                groupid: 'PL40',
                enable: true,
                modelDir: 'models/Medtronic/',
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                tagConnect: true,
                data: [
                    {
                        load: true,
                        visible: true,
                        name: '6069076_0.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'tag1',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6069076_2-75.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6069076_5-5.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6069076_8-25.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6069076_11.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6069076_13-75.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6069076_16-5.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6069076_19-25.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                    {
                        load: true,
                        visible: false,
                        name: '6069076_22.glb',
                        position: [-6, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [1000, 1000, 1000],
                        tagid: 'NONE',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    },
                ],
            }
        ],
        tags: [
            {
                groupid: 'tag1',
                enable: true,
                imageDir: 'img/Medtronic/tags/',
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                faceTagToCamera: true,
                initiallyOn: false,
                clickAction: false,
                actionType: 'None',
                data: [
                    {
                        load: true,
                        name: 'pltag1',
                        image: 'pltag1a.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        linewidth: 2,
                        imageposition: [-14, 15, 0],
                        footposition: [-7, 8.5, 0],
                        rotation: [0, 0, 0],
                        scale: [12, 3, 1],
                    },
                    {
                        load: true,
                        name: 'pltag2',
                        image: 'pltag2a.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        linewidth: 2,
                        imageposition: [6, 15, -10],
                        footposition: [5, 8.5, -3],
                        rotation: [0, 0, 0],
                        scale: [12, 3, 1],
                    },
                    {
                        load: true,
                        name: 'pltag3',
                        image: 'pltag3a.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        linewidth: 2,
                        imageposition: [5, 15, 12],
                        footposition: [6, 8.5, 3],
                        rotation: [0, 0, 0],
                        scale: [12, 3, 1],
                    },
                    {
                        load: true,
                        name: 'pltag3t',
                        image: 'transparent16px.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        linewidth: 2,
                        imageposition: [5, 15, 12],
                        footposition: [14, 8, -1],
                        rotation: [0, 0, 0],
                        scale: [12, 3, 1],
                    },
                    {
                        load: true,
                        name: 'pltag4',
                        image: 'pltag4a.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        linewidth: 2,
                        imageposition: [20, 12, -10],
                        footposition: [19.2, 6.5, -7.5],
                        rotation: [0, 0, 0],
                        scale: [12, 3, 1],
                    },
                    {
                        load: true,
                        name: 'pltag5',
                        image: 'pltag5a.png',
                        drawLine: true,
                        linecolor: 0xFFFFFF,
                        linewidth: 2,
                        imageposition: [18, 14, 4],
                        footposition: [17, 8, -4],
                        rotation: [0, 0, 0],
                        scale: [12, 3, 1],
                    }

                ]
            }
        ],
        gui: {
            enable: true,
            hide: true,
            title: 'GUI',
            width: 240,
            groups: [
                {
                    folder: false,
                    category: 'Input',
                    open: true,
                    items: [
                        //{ name: 'Type', value: { PL: 0, PL40: 1 } },
                        //{name:'Configuration', value:{'Close':0, '5.5deg':1, '11deg':2, '16.5deg':3, 'Open':4}},
                        { name: 'Angle', value: 0, range: [0, 22, 2.75] },
                        //{name:'Opacity', value:1, range:[0, 1, 0.02]},
                        //{ name: 'Direction', value: ['CW', 'CCW', 'NONE'] },
                    ]
                },
            ]
        }
    },
    // index=4: JAEC2022 Season's Greeting
    {
        overall: {
            query: {
                enable: false,
            },
            html: {
                title: "Season's Greeting from JAEC"
            },
            renderer: {
                disable: false,
                sRGB: true,
                physicallyCorrectLights: true,
                //toneMapping: 'ACESFilmic',
                toneMapping: 'None',
                shadowMap: true,
                clearColor: 0xFFFFFF,
                clearAlpha: 1.0,
            },
            scene: {
                bgColor: 0x000033,
            },
            doAnimation: false,
            raycaster: {
                useRaycast: true,
                markerPrefix: 'm',
                tagPrefix: 't',
            },
            axes: {
                enable: false,
                length: 100,
                position: [0, 0, 0],
            },
            grid: {
                enable: false,
                size: 200,
                divisions: 40,
                colorCenter: 0xF5F5F5,
                colorGrid: 0xF5F5F5,
                transparent: true,
                opacity: 0.4,
            }
        },
        debug: {
            level: 1,
            clearForProduction: false,
        },
        navigation: {
            data: [
                {
                    type: 'link',
                    enable: false,
                    btnContainerID: 'header_ul',
                    btnID: 'logo',
                    btnClass: 'logoPL',
                    imageFile: 'img/JAEC/jaec_logo2w_128.png',
                    linkURL: 'http://www.jaec.or.jp/',
                },
                {
                    type: 'sound',
                    enable: true,
                    btnContainerID: 'header_ul',
                    btnID: 'btn_sound',
                    iconOnFile: 'img/buttons/btn_sound_on.png',
                    iconOffFile: 'img/buttons/btn_sound_off.png"',
                    autoStart: false,
                    volumeMaster: 1.0,
                    dataDirectory: 'sounds/winter/',
                    index: 0,
                    data: [
                        {
                            //fileName:'that-s-karuizawa.mp3',
                            //fileName: 'orgel-niyoru-aria.mp3',
                            fileName: 'm13_beethoven_sonata.mp3',
                            volume: 0.3,
                        }
                    ]
                },
                {
                    name: 'JAEC',
                    type: 'sidelink',
                    enable: true,
                    visible: true,
                    //class: 'exit',
                    css: {
                        class: 'exit',
                        bottom: '20px',
                    },
                    targetID: 'sidenav',
                    //buttonImage: 'img/JAEC/jaec_logo2w_128.png',
                    buttonImage: 'img/JAEC/jaec_logo3_w320.png',
                    function: 'url',   //'url':指定したurlへ 'back':呼び出し元へ（次のurlパラメータは無視）
                    urlIndex: 0,     //urls[]のどれを有効にするか
                    urls: [
                        'http://www.jaec.or.jp/'
                    ],
                    linkTarget: '_self',      //リンクターゲット'_self'または'_blank'。 'back'の場合は強制的に'_blank'にする
                },
            ]
        },

        camera: {
            initialIndex: 0,
            group: [
                {
                    name: 'Main',
                    position: [0, 0, 0],
                    lookAt: [0, 0, 0],
                    fov: 45,
                    near: 5,
                    far: 32,
                    orbitControl: {
                        enable: true,
                        target: [0, 0, 0],
                        offset: [10, 6, -10],
                        enableZoom: true,
                        enablePan: true,
                        enableDamping: true,
                        dampingFactor: 0.08,
                        minDistance: 8,
                        maxDistance: 20,
                        minPolarAngle: 0.0,
                        maxPolarAngle: Math.PI,
                        autoRotate: true,
                        autoRotateSpeed: 1.0,
                    },
                }
            ]
        },
        lights: {
            ambient: [
                { color: 0xffffff, intensity: 0.3 }
            ],
            hemisphere: [
                //{skycolor:0xffffff, goundcolor:0xff00ff, intensity:5.0}
            ],
            directional: [
                { color: 0xffffff, intensity: 0.5, position: [10, 5, 10], castShadow: false, showHelper: false },
            ],
            //point:[{color:0xffffff, intensity:30.0, distance:20, position: [10,5,10], showHelper:false}],
            point: [
                //{color:0xffffff, intensity:30.0, distance:20, position: [15,0,0], showHelper:false},
            ],
            spot: [
                //{color:0xffffff, intensity:30.0, distance:30, angle:60, exponent:10, position: [20,0,0], castShadow:true, showHelper:true},
            ],
            area: [
                //{color:0xffffff, intensity:30.0, width:1.0, height:1.0, position: [0,0,0], rotation:[0,0,0]}
            ]
        },
        skybox: {
            enable: true,
            imageDir: 'img/JAEC/',
            //image: 'panorama_jaec2022.jpg',
            image: 'STUDIOH_036_1500.png',
            setEnvironmentMap: true,
        },
        environmentMap: {
            enable: false,
            imageDir: 'img/skybox/',
            image: 'white.png',
            useLightprobe: false,
        },
        domes: {
            enable: false,
        },
        billboards: [
            {
                enable: false,
            }
        ],
        models: [
            {
                groupid: 'MainModel',
                enable: true,
                modelDir: 'models/low_poly_christmas_island_gltf/',
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                tagConnect: false,
                data: [
                    {
                        load: true,
                        visible: true,
                        //name: 'scene.gltf',
                        name: 'christmasball2022.glb',
                        position: [0, 0, 0],
                        rotation: [0, 0, 0],
                        scale: [12, 12, 12],
                        tagid: 'tag1',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    }
                ],
            },
            {
                groupid: 'RingMessage',
                enable: true,
                modelDir: 'models/winter_at_home/',
                position: [0, 0, 0],
                rotation: [0, 180, 0],
                tagConnect: false,
                data: [
                    {
                        load: true,
                        visible: true,
                        name: 'ringcylinder.glb',
                        position: [0, 3, 0],
                        rotation: [0, 0, 0],
                        scale: [-20, 20, 20],
                        tagid: 'tag2',
                        animation: {
                            enable: true,
                            rotSpeed: [0.0, 5.0, 0.0]
                        }
                    }
                ],
            },
            {
                groupid: 'Airplane',
                enable: true,
                modelDir: 'models/a320/',
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                tagConnect: false,
                data: [
                    {
                        load: true,
                        visible: true,
                        name: 'scene.gltf',
                        position: [-4, 5, 0],
                        rotation: [0, 0, 0],
                        scale: [0.001, 0.001, 0.001],
                        tagid: 'tag1',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    }
                ],
            },
        ],
        tags: [
            {
                groupid: 'tag2',
                enable: false,
            }
        ],
        primitives: [
            {
                groupid: 'GlassBall',
                enable: false,
                visible: true,
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                data: [
                    {
                        enable: true,
                        visible: true,
                        geometry: {
                            type: 'sphere',
                            radius: 1.0,
                            widthSeg: 36,
                            heightSeg: 36,
                        },
                        material: {
                            type: 'standard',
                            property: {
                                color: 0x333333,
                                transparent: true,
                                opacity: 0.5,
                                roughness: 0.2,
                                depthTest: false,
                            }
                        },
                        position: [0, 1.6, 0],
                        rotation: [0, 0, 0],
                        scale: [8.8, 8.8, 8.8],
                    }
                ]
            },
            {
                groupid: 'Signature',
                enable: false,
                visible: true,
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                data: [
                    {
                        enable: true,
                        visible: true,
                        geometry: {
                            type: 'plane',
                            width: 1.0,
                            height: 1.0,
                            widthSeg: 1,
                            heightSeg: 1,
                        },
                        material: {
                            type: 'basic',
                            addTexture: true,
                            image: 'img/JAEC/jaec_logo.png',
                            property: {
                                color: 0xFFFFFF,
                                side: 0, //0:Front, 1:Back, 2:Both
                                transparent: true,
                                //opacity:1.0,
                                //depthTest:false,
                            }
                        },
                        position: [0, 3, 3],
                        rotation: [0, 0, 0],
                        scale: [10.0, 10.0, 10.0],
                    }
                ]
            },
        ],
        particles: [
            {
                groupid: 'snow',
                enable: true,
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                data: [
                    {
                        enable: true,
                        visible: true,
                        shape: {
                            type: 'box',
                            xmax: 10,
                            xmin: -10,
                            ymax: 12.0,
                            ymin: 0.0,
                            zmax: 10,
                            zmin: -10,
                        },
                        velocity: {
                            xmin: 0.0,
                            xmax: 0.0,
                            ymin: -0.7,
                            ymax: -1.3,
                            zmin: 0.0,
                            zmax: 0.0,
                        },
                        amount: 100, //パーティクルの数
                        material: {
                            type: 'points',
                            addTexture: true,
                            image: 'img/particles/Flare.png',
                            hsl: [1, 1, 1],  //[H,S,L] 0.0-1.0で指定
                            property: {
                                size: 0.5,
                                color: 0xFFFFFF,
                                opacity: 0.7,
                                blending: 2,
                                depthTest: false,
                                transparent: true,
                            },
                        },
                    }
                ]
            }
        ],
        gui: {
            enable: false,
            hide: false,
            title: 'GUI',
            width: 240,
            groups: [
                {
                    folder: false,
                    category: 'Input',
                    open: true,
                    items: [
                        //{ name: 'Type', value: { PL: 0, PL40: 1 } },
                        //{name:'Configuration', value:{'Close':0, '5.5deg':1, '11deg':2, '16.5deg':3, 'Open':4}},
                        { name: 'Angle', value: 0, range: [0, 22, 2.75] },
                        //{name:'Opacity', value:1, range:[0, 1, 0.02]},
                        //{ name: 'Direction', value: ['CW', 'CCW', 'NONE'] },
                    ]
                },
            ]
        }
    },
    // index=5: IHI2022 Season's Greeting
    {
        overall: {
            query: {
                enable: false,
            },
            html: {
                title: "Season's Greeting from IHI"
            },
            renderer: {
                disable: false,
                sRGB: true,
                physicallyCorrectLights: true,
                //toneMapping: 'ACESFilmic',
                toneMapping: 'None',
                shadowMap: true,
                clearColor: 0xFFFFFF,
                clearAlpha: 1.0,
            },
            scene: {
                bgColor: 0x000033,
            },
            doAnimation: false,
            raycaster: {
                useRaycast: true,
                markerPrefix: 'm',
                tagPrefix: 't',
            },
            axes: {
                enable: false,
                length: 100,
                position: [0, 0, 0],
            },
            grid: {
                enable: false,
                size: 200,
                divisions: 40,
                colorCenter: 0xF5F5F5,
                colorGrid: 0xF5F5F5,
                transparent: true,
                opacity: 0.4,
            }
        },
        debug: {
            level: 1,
            clearForProduction: false,
        },
        navigation: {
            data: [
                {
                    type: 'link',
                    enable: false,
                    btnContainerID: 'header_ul',
                    btnID: 'logo',
                    btnClass: 'logoPL',
                    imageFile: 'img/IHI/ihi_logo_w160.png',
                    linkURL: 'http://xooms.co.jp',
                },
                {
                    type: 'sound',
                    enable: false,
                    btnContainerID: 'header_ul',
                    btnID: 'btn_sound',
                    iconOnFile: 'img/buttons/btn_sound_on.png',
                    iconOffFile: 'img/buttons/btn_sound_off.png"',
                    autoStart: false,
                    volumeMaster: 1.0,
                    dataDirectory: 'sounds/winter/',
                    index: 0,
                    data: [
                        {
                            fileName: 'M-0708.mp3',
                            volume: 0.3,
                        }
                    ]
                },
                {
                    name: 'IHI',
                    type: 'sidelink',
                    enable: false,
                    visible: true,
                    css: {
                        class: 'exit',
                    },
                    targetID: 'sidenav',
                    buttonImage: 'img/IHI/ihi_logo_w160.png',
                    function: 'url',   //'url':指定したurlへ 'back':呼び出し元へ（次のurlパラメータは無視）
                    urlIndex: 0,     //urls[]のどれを有効にするか
                    urls: [
                        'https://www.ihi.co.jp/recruit/ihi/whats/'
                    ],
                    linkTarget: '_self',      //リンクターゲット'_self'または'_blank'。 'back'の場合は強制的に'_blank'にする
                },
            ]
        },

        camera: {
            initialIndex: 0,
            group: [
                {
                    name: 'Main',
                    position: [0, 0, 0],
                    lookAt: [0, 0, 0],
                    fov: 45,
                    near: 5,
                    far: 32,
                    orbitControl: {
                        enable: false,
                        target: [0, 0, 0],
                        offset: [13, 7, -13],
                        enableZoom: true,
                        enablePan: true,
                        enableDamping: true,
                        dampingFactor: 0.08,
                        minDistance: 10,
                        maxDistance: 30,
                        minPolarAngle: 0.0,
                        maxPolarAngle: Math.PI,
                        autoRotate: false,
                        autoRotateSpeed: 1.0,
                    },
                    animation: {
                        enable: true,
                        type: 'polar',   //アニメーションタイプ 'ploar':半径r,角度[p,q,r]を指定。
                        restriction: {
                            apply: true,
                            minRadius: 1.0,  //半径の最小値
                            maxRadius: 20.0, //半径の最大値
                        },
                        keys: [
                            { time: 0.0, radius: 16, phi: 0, theta: -240, lookAt: [0, 2, 0], offset: [0, 0, 0] },
                            { time: 48.0, radius: 12, phi: 15, theta: 240, lookAt: [0, 2, 0], offset: [0, 0, 0] },
                            { time: 56.0, radius: 6, phi: 88, theta: 240, lookAt: [0, 2, 0], offset: [0, 0, 0] },
                        ]
                    }
                }
            ]
        },
        lights: {
            ambient: [
                { color: 0xffffff, intensity: 0.3 }
            ],
            hemisphere: [
                //{skycolor:0xffffff, goundcolor:0xff00ff, intensity:5.0}
            ],
            directional: [
                { color: 0xffffff, intensity: 1.0, position: [10, 5, 10], castShadow: false, showHelper: false },
            ],
            //point:[{color:0xffffff, intensity:30.0, distance:20, position: [10,5,10], showHelper:false}],
            point: [
                //{color:0xffffff, intensity:30.0, distance:20, position: [15,0,0], showHelper:false},
            ],
            spot: [
                //{color:0xffffff, intensity:30.0, distance:30, angle:60, exponent:10, position: [20,0,0], castShadow:true, showHelper:true},
            ],
            area: [
                //{color:0xffffff, intensity:30.0, width:1.0, height:1.0, position: [0,0,0], rotation:[0,0,0]}
            ]
        },
        skybox: {
            enable: true,
            imageDir: 'img/IHI/skybox/',
            image: 'ihigreeting2022a.jpg',
            setEnvironmentMap: true,
        },
        environmentMap: {
            enable: false,
            imageDir: 'img/skybox/',
            image: 'white.png',
            useLightprobe: false,
        },
        domes: {
            enable: false,
        },
        billboards: [
            {
                enable: false,
            }
        ],
        models: [
            {
                groupid: 'MainModel',
                enable: true,
                modelDir: 'models/ihi/',
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                tagConnect: false,
                data: [
                    {
                        load: true,
                        visible: true,
                        name: 'christmasballIHI2022simpleMod.glb',
                        position: [0, 0, 0],
                        rotation: [0, 90, 0],
                        scale: [0.05, 0.05, 0.05],
                        tagid: 'tag1',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    }
                ],
            },
            {
                groupid: 'RingMessage',
                enable: false,
                modelDir: 'models/winter_at_home/',
                position: [0, 0, 0],
                rotation: [0, 180, 0],
                tagConnect: false,
                data: [
                    {
                        load: true,
                        visible: true,
                        name: 'ringcylinder.glb',
                        position: [0, 3, 0],
                        rotation: [0, 90, 0],
                        scale: [-30, 30, 30],
                        tagid: 'tag2',
                        animation: {
                            enable: true,
                            rotSpeed: [0.0, 5.0, 0.0]
                        }
                    }
                ],
            },
            {
                groupid: 'JetEngine',
                enable: true,
                modelDir: 'models/ihi/',
                position: [0, 0, 0],
                rotation: [0, 90, 0],
                tagConnect: false,
                data: [
                    {
                        load: true,
                        visible: true,
                        name: 'JetEngineBodyRev.glb',
                        position: [0, -1.6, 0],
                        rotation: [0, 190, 0],
                        scale: [0.01, 0.01, 0.01],
                        tagid: 't1',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    }
                ],
            },
            {
                groupid: 'Snowman1',
                enable: true,
                modelDir: 'models/ihi/',
                position: [0, 0, 0],
                rotation: [0, 90, 0],
                tagConnect: false,
                data: [
                    {
                        load: true,
                        visible: true,
                        name: 'pinkscarf.glb',
                        position: [0, -2, 0],
                        rotation: [0, 45, 0],
                        scale: [0.01, 0.01, 0.01],
                        tagid: 's1',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    }
                ],
            },
            {
                groupid: 'Snowman2',
                enable: true,
                modelDir: 'models/ihi/',
                position: [0, 0, 0],
                rotation: [0, 90, 0],
                tagConnect: false,
                data: [
                    {
                        load: true,
                        visible: true,
                        name: 'yellowscarf.glb',
                        position: [-4, -1.2, -5],
                        rotation: [0, 45, 0],
                        scale: [0.01, 0.01, 0.01],
                        tagid: 's1',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    }
                ],
            },
            {
                groupid: 'Airplane',
                enable: true,
                modelDir: 'models/ihi/',
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                tagConnect: false,
                data: [
                    {
                        load: true,
                        visible: true,
                        name: 'airplane.glb',
                        position: [5, 5, 0],
                        rotation: [0, 180, 0],
                        scale: [0.003, 0.003, 0.003],
                        tagid: 'ap1',
                        animation: {
                            enable: false,
                            rotSpeed: [0.0, 0.0, 0.0]
                        }
                    }
                ],
            },
        ],
        tags: [
            {
                groupid: 'tag2',
                enable: false,
            }
        ],
        primitives: [
            {
                groupid: 'GlassBall',
                enable: false,
                visible: true,
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                data: [
                    {
                        enable: true,
                        visible: true,
                        geometry: {
                            type: 'sphere',
                            radius: 1.0,
                            widthSeg: 36,
                            heightSeg: 36,
                        },
                        material: {
                            type: 'standard',
                            property: {
                                color: 0x333333,
                                transparent: true,
                                opacity: 0.5,
                                roughness: 0.2,
                                depthTest: false,
                            }
                        },
                        position: [0, 1.6, 0],
                        rotation: [0, 0, 0],
                        scale: [8.8, 8.8, 8.8],
                    }
                ]
            },
            {
                groupid: 'Signature',
                enable: false,
                visible: true,
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                data: [
                    {
                        enable: true,
                        visible: true,
                        geometry: {
                            type: 'plane',
                            width: 1.0,
                            height: 1.0,
                            widthSeg: 1,
                            heightSeg: 1,
                        },
                        material: {
                            type: 'basic',
                            addTexture: true,
                            image: 'img/JAEC/jaec_logo.png',
                            property: {
                                color: 0xFFFFFF,
                                side: 0, //0:Front, 1:Back, 2:Both
                                transparent: true,
                                //opacity:1.0,
                                //depthTest:false,
                            }
                        },
                        position: [0, 3, 3],
                        rotation: [0, 0, 0],
                        scale: [10.0, 10.0, 10.0],
                    }
                ]
            },
        ],
        particles: [
            {
                groupid: 'snow',
                enable: true,
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                data: [
                    {
                        enable: true,
                        visible: true,
                        shape: {
                            type: 'box',
                            xmax: 10,
                            xmin: -10,
                            ymax: 12.0,
                            ymin: 0.0,
                            zmax: 10,
                            zmin: -10,
                        },
                        velocity: {
                            xmin: 0.0,
                            xmax: 0.0,
                            ymin: -0.7,
                            ymax: -1.3,
                            zmin: 0.0,
                            zmax: 0.0,
                        },
                        amount: 100, //パーティクルの数
                        material: {
                            type: 'points',
                            addTexture: true,
                            image: 'img/particles/Flare.png',
                            hsl: [1, 1, 1],  //[H,S,L] 0.0-1.0で指定
                            property: {
                                size: 0.5,
                                color: 0xFFFFFF,
                                opacity: 0.7,
                                blending: 2,
                                depthTest: false,
                                transparent: true,
                            },
                        },
                    }
                ]
            }
        ],
        gui: {
            enable: false,
            hide: false,
            title: 'GUI',
            width: 240,
            groups: [
                {
                    folder: false,
                    category: 'Input',
                    open: true,
                    items: [
                        //{ name: 'Type', value: { PL: 0, PL40: 1 } },
                        //{name:'Configuration', value:{'Close':0, '5.5deg':1, '11deg':2, '16.5deg':3, 'Open':4}},
                        { name: 'Angle', value: 0, range: [0, 22, 2.75] },
                        //{name:'Opacity', value:1, range:[0, 1, 0.02]},
                        //{ name: 'Direction', value: ['CW', 'CCW', 'NONE'] },
                    ]
                },
            ]
        }
    }
]